// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/vector-title.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/preloader.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/down-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/check.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/social-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/social-bg-hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/tournament/x50-hero-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/todays-winner-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/plus-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/minus-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/jackpot-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/double-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/double-left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/arrow-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/games-inner-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/tournament/x50-hero.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/right-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/left-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Roboto:wght@100;300;400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset css start */
/* @import url("https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;600;700&family=Roboto:wght@100;300;400;500;700;900&display=swap"); */
:root {
  --body-font: "Inter", sans-serif;
  --body-alt-font: "Inter", sans-serif;
  --body-color: rgb(255, 255, 255);
  --body-bg: #000000;
}

html {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  font-family: var(--body-font);
  background-color: var(--body-bg);
  font-size: 18px;
  line-height: 25px;
  padding: 0;
  margin: 0;
  font-weight: 400;
  overflow-x: hidden;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
}

h1,
h1 > a,
h2,
h2 > a,
h3,
h3 > a,
h4,
h4 > a,
h5,
h5 > a,
h6,
h6 > a {
  font-family: var(--body-alt-font);
  color: var(--body-color);
  line-height: 1.25;
  font-weight: 600;
  text-transform: initial;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
}

h1 > a:hover,
h2 > a:hover,
h3 > a:hover,
h4 > a:hover,
h5 > a:hover,
h6 > a:hover {
  color: var(--body-color);
}

h1,
h1 > a {
  font-size: 76px;
  line-height: 91.2px;
}

h2,
h2 > a {
  font-size: 57px;
  line-height: 68.4px;
}

h3,
h3 > a {
  font-size: 43px;
  line-height: 51.6px;
}

h4,
h4 > a {
  font-size: 32px;
  line-height: 38.4px;
}

h5,
h5 > a {
  font-size: 24px;
  line-height: 28px;
}

h6,
h6 > a {
  font-size: 18px;
  line-height: 21.6px;
}

table thead tr th {
  font-size: 18px;
  line-height: 21.6px;
}

a {
  display: inline-block;
  color: var(--body-color);
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
}

a,
a:focus,
a:hover {
  text-decoration: none;
  outline: none;
  color: rgb(255, 255, 255);
}

p,
span,
li {
  margin: 0;
  font-family: var(--body-font);
  font-size: 18px;
  font-weight: 400;
  color: #dce6ff;
  line-height: 25px;
}

img {
  max-width: 100%;
  height: auto;
}

ul,
ol {
  padding: 0;
  margin: 0;
  list-style: none;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
}

input:focus,
textarea:focus {
  outline: none;
  box-shadow: none;
}

button {
  border: none;
  cursor: pointer;
}

input,
textarea {
  padding: 10px 25px;
  border: 1px solid #4450b8;
  width: 100%;
  font-family: var(--body-font);
}

select {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  outline: none;
}

textarea {
  min-height: 150px;
  resize: none;
}

span {
  display: inline-block;
}

.table thead th,
.table td,
.table th {
  border: none;
}

.main-container {
  margin-top: 100px;
  margin-bottom: 100px;
}

.bg_img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.bg_img {
  background-position: center;
  background-size: cover;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mr-60 {
  margin-right: 60px;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.d-grid {
  display: grid !important;
}

.button-group {
  display: inline-flex;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: center;
}

.b-none {
  border: none !important;
}

.section-header {
  margin-top: -12px;
  margin-bottom: 56px;
}

.title {
  font-family: var(--body-alt-font);
  color: var(--body-color);
  font-weight: 700;
  /* text-transform: uppercase; */
  margin-bottom: 20px;
  text-align: center;
}

.title span {
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  font-weight: inherit;
  color: #04f0f6;
}

.vector-title {
  padding: 16px 80px 16px 80px;
  margin-bottom: -26px;
  font-size: 32px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top center;
  background-repeat: no-repeat;
  color: #000000;
}

iframe {
  border: 0;
  width: 100%;
}

@media (max-width: 991px) {
  .section-title {
    font-size: 40px;
  }
}

@media (max-width: 575px) {
  .sub-title,
  .sub-title-alt {
    font-size: 12px;
  }
}

.section-title span {
  color: var(--primary-color);
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  font-weight: inherit;
}

.shadow-none {
  box-shadow: none;
}

.mb-30-none {
  margin-bottom: -30px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-40 {
  margin-bottom: 40px;
}

.mb-40-none {
  margin-bottom: -40px;
}

.mt-30 {
  margin-top: 30px;
}

.pt-120 {
  padding-top: 120px;
}

@media (max-width: 991px) {
  .pt-120 {
    padding-top: 60px;
  }
}

@media (max-width: 575px) {
  .pt-120 {
    padding-top: 50px;
  }
}

.pb-120 {
  padding-bottom: 120px;
}

@media (max-width: 991px) {
  .pb-120 {
    padding-bottom: 60px;
  }
}

@media (max-width: 575px) {
  .pb-120 {
    padding-bottom: 50px;
  }
}

.pt-60 {
  padding-top: 60px;
}

@media (max-width: 991px) {
  .pt-60 {
    padding-top: 30px;
  }
}

@media (max-width: 575px) {
  .pt-60 {
    padding-top: 25px;
  }
}

.pb-60 {
  padding-bottom: 60px;
}

@media (max-width: 991px) {
  .pb-60 {
    padding-bottom: 30px;
  }
}

@media (max-width: 575px) {
  .pb-60 {
    padding-bottom: 25px;
  }
}

body::-webkit-scrollbar {
  width: 4px;
}

body::-webkit-scrollbar-track {
  background: #00003e;
}

body::-webkit-scrollbar-thumb {
  background: #535264;
}

body::-webkit-scrollbar-thumb:hover {
  background: #535264;
}

@media (max-width: 991px) {
  .header-section .header-top {
    display: block;
  }
}

@media (max-width: 991px) {
  .navbar-collapse .main-menu {
    height: 280px;
    overflow-y: auto;
  }
}

.navbar-collapse .main-menu .menu_has_children.show .sub-menu {
  display: grid;
}

@media (max-width: 991px) {
  .menu_has_children .sub-menu {
    display: none !important;
  }
  .menu_has_children .sub-menu li {
    width: 100%;
  }
  .navbar-collapse .main-menu .menu_has_children.show .sub-menu {
    display: inline-flex !important;
    flex-wrap: wrap;
    margin-left: 20px;
  }
}

.navbar-collapse .main-menu li:last-child .sub-menu {
  left: auto;
  right: 0;
}

.navbar-collapse .main-menu .cart span {
  background-color: rgba(183, 165, 255, 0.2);
  color: #fff;
  padding: 0 20px;
  border-radius: 15px;
  margin-left: 5px;
}

.navbar-collapse .main-menu .cart-area {
  top: 40px;
}

.navbar-collapse .main-menu .cart-area button {
  background-color: transparent;
  color: var(--body-color);
  margin: 0 15px;
  font-weight: 500;
}

.navbar-collapse .main-menu li {
  position: relative;
}

.navbar-collapse .main-menu li:hover .sub-menu {
  opacity: 1;
  visibility: visible;
  top: 100%;
}

.navbar-collapse .main-menu li.menu_has_children {
  position: relative;
}

.navbar-collapse .main-menu li.menu_has_children i {
  font-size: 18px;
  margin-left: 5px;
}

@media (max-width: 991px) {
  .navbar-collapse .main-menu li.menu_has_children::before {
    top: 12px;
    right: 15px;
  }
}

.navbar-collapse .main-menu li a {
  padding: 40px 25px;
  font-weight: 800;
  font-family: var(--body-font);
  font-size: 18px;
  text-transform: capitalize;
}

@media (max-width: 991px) {
  .navbar-collapse .main-menu li a {
    padding: 10px 8px;
    display: block;
  }
  .navbar-expand-lg {
    float: right;
    width: 100%;
  }
}

.navbar-collapse .main-menu li .sub-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 230px;
  background-color: #0d0d59;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 9;
}

.navbar-collapse .main-menu li .sub-menu li:last-child a {
  border: none;
}

.navbar-collapse .main-menu li .sub-menu li a {
  padding: 15px 20px;
  display: block;
  border-bottom: 1px solid #7400d3;
}

.navbar-collapse .main-menu li .sub-menu li a:hover {
  border-radius: 0 !important;
}

.nav-area {
  display: contents;
  justify-content: space-between;
  z-index: 100;
}

@media (max-width: 991px) {
  .navbar-collapse .main-menu li .sub-menu {
    position: initial;
    opacity: 1;
    visibility: visible;
    display: none;
    transition: none;
  }
}

.menu-toggle {
  margin: 15px 0;
  position: relative;
  display: block;
  width: 35px;
  height: 20px;
  cursor: pointer;
  background: transparent;
  border-top: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  font-size: 0;
  transition: all 0.25s ease-in-out;
}

.menu-toggle.is-active {
  border-color: transparent;
}

.menu-toggle::before,
.menu-toggle::after {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #ffffff;
  transform: translate(-50%, -50%);
  transition: transform 0.25s ease-in-out;
}

.menu-toggle.is-active::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.menu-toggle.is-active::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.navbar-toggler {
  padding-right: 0;
  display: none;
}

.toggle-btn {
  padding: 8px 12px;
  color: var(--body-color);
  font-weight: 500;
  text-transform: capitalize;
  border: 1px solid transparent;
  transition: all 0.3s;
  border-radius: 4px;
}

.header-section .header-bottom {
  padding: 10px 10px;
}

@media (max-width: 991px) {
  .navbar-toggler {
    display: inline-block;
  }
  .navbar-light .navbar-toggler {
    position: absolute;
    right: 14%;
    margin-top: 5px;
    border: none;
  }
  .header-area {
    position: relative;
    padding: 15px 0;
  }
  #header-section .navbar .navbar-brand img {
    max-width: initial;
  }
  #header-section .navbar .navbar-brand {
    margin-top: -5px;
    width: 35%;
  }
  .navbar-collapse .main-menu {
    padding-top: 30px;
  }
  #header-section .navbar .navbar-bottom {
    padding: 20px 0;
  }
  #header-section .navbar .navbar-top {
    justify-content: center !important;
  }
  #header-section {
    background-color: var(--body-bg) !important;
  }
  #header-section .overlay .navbar-toggler i {
    color: var(--body-color);
  }
  #header-section .navbar .navbar-nav .menu_has_children::after {
    transform: translateX(70px);
    left: 0;
  }
}

@media (max-width: 800px) {
  .navbar-light .navbar-toggler {
    right: 4%;
  }
}

@media (max-width: 440px) {
  #header-section .navbar .navbar-top .language-select-list img {
    display: none;
  }
  #header-section .navbar .navbar-top a {
    margin: 0 6px !important;
    font-size: 12px;
  }
  #header-section .navbar .navbar-top .language-select-list {
    margin: 0 !important;
  }
  #header-section .navbar .nice-select .option,
  #header-section .navbar .nice-select.select-bar .current {
    font-size: 12px;
  }
  #header-section .navbar .navbar-brand img {
    max-width: initial;
    width: 115px;
  }
  .navbar-light .navbar-toggler {
    margin-top: 0;
  }
  #header-section .navbar .navbar-collapse .navbar-nav {
    padding-right: 0;
  }
}

.scrollToTop {
  position: fixed;
  bottom: 0;
  right: 30px;
  width: 45px;
  height: 45px;
  background-color: #4e01ce;
  border-radius: 5px;
  color: #fff;
  line-height: 45px;
  font-size: 20px;
  text-align: center;
  z-index: 9;
  cursor: pointer;
  transition: all 1s;
  transform: translateY(100%);
}

.scrollToTop.active {
  bottom: 30px;
  transform: translateY(0%);
  color: #fff;
}

.scrollToTop:hover {
  color: #fff;
}

.preloader {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 99999999;
  overflow: visible;
  background: #00003e url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: 400px 400px;
  display: none;
}

#header-section.header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background-color: #00003e;
  box-shadow: 0px 3px 10px 0px rgb(0 0 0 / 30%);
}

#header-section.header-fixed .header-top,
#header-section.header-fixed .header-middle {
  display: none !important;
}

#header-section.header-fixed .header-bottom {
  background-color: var(--body-color);
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
}

#header-section .header-top {
  padding: 20px 0;
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInDown {
  animation-name: fadeInDown;
}

@keyframes zoomInOut {
  50% {
    transform: scale(1.2);
  }
}

@keyframes ripple2Ani {
  0% {
    transform: translate(0px, 0px);
  }
  33% {
    transform: translate(-5px, -5px);
  }
  66% {
    transform: translate(5px, 5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes rippleAni {
  0% {
    transform: translate(0px, 0px);
  }
  33% {
    transform: translate(5px, -5px);
  }
  66% {
    transform: translate(-5px, 5px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}

@keyframes zoominout {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1.2);
  }
  100% {
    transform: scale(1, 1);
  }
}

.TournamentEnrollment { 
  width:100%; 
  border-radius: 0px!important;
  background-color: #00ccff!important;
  color: white!important;
  padding: 10px 20px;
  font-size: 1em; 
  border-top: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  border-left: 0px;
  box-shadow: 0px!important; 
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 250  px;  
}
/* cmn btn */
.cmn-btn {
  position: relative;
  color: rgb(255, 255, 255);
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  background: #04f0f6;  
  transition: all ease 0.3s;
  padding: 12px 30px;
}

.cmn-btn:hover {
  background: #04f0f6;
  box-shadow: 0px 4px 0px #04f0f6;
  transition: all ease 0.3s;
}

.cmn-btn img {
  margin-bottom: 4px;
  margin-left: 4px;
}

.cmn-btn-alt {
  background: #4e01ce;
  box-shadow: 0px 4px 0px #4707b3;
}

.cmn-btn-alt:hover {
  background: #7400d3;
  box-shadow: 0px 4px 0px #57049a;
}

.cmn-btn-second {
  padding: 8px 15px;
  border-radius: 25px;
  border: 1px solid #be97ff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: #ffffff;
  background: transparent;
  transition: all ease 0.3s;
}

.cmn-btn-second:hover {
  border: 1px solid #7400d3;
  background: #7400d3;
  transition: all ease 0.3s;
}

/* header area */
#header-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  background-color: transparent;
}

#header-section .site-logo {
  margin-top: -4px;
}

#header-section .header-area {
  border-bottom: 1px solid #04f0f6;
  background-color: rgba(0, 0, 0, 0.5);
  padding:10px;
}

#header-section.header-fixed .header-area {
  border: none;
}

#header-section .navbar .navbar-nav .dropdown a,
#header-section .right-area span,
#header-section .navbar .navbar-nav li a {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  text-transform: uppercase;
}

#header-section .navbar .navbar-nav li a.active,
#header-section .navbar .navbar-nav li a:hover {
  color: #04f0f6;
}

#header-section .navbar .navbar-nav .menu_has_children a {
  padding-right: 40px;
}

#header-section .navbar .navbar-nav .menu_has_children {
  display: grid;
  align-items: center;
}

#header-section .navbar .navbar-nav .menu_has_children::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  height: 7px;
  width: 15px;
  right: 15px;
  transition: all ease 0.3s;
}

#header-section .navbar .navbar-nav .dropdown {
  display: flex;
  align-items: center;
}

#header-section .right-area .nice-select {
  padding-left: 5px;
}

#header-section .right-area .cmn-btn {
  margin-left: 10px;
}

#header-section .nice-select:after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  height: 7px;
  width: 15px;
  right: 6px;
  transition: all ease 0.3s;
  border: none;
  transform: rotate(0deg);
}

#header-section .nice-select.open:after {
  transform: rotate(-180deg);
  right: 15px;
  margin-top: -5px;
}

#header-section .nice-select.open .list {
  background-color: #0d0d59;
}

#header-section .nice-select .option:hover,
#header-section .nice-select .option.focus,
#header-section .nice-select .option.selected.focus {
  background-color: transparent;
  color: #04f0f6;
}

/* modal */
/* .modal-backdrop {
  height: initial;
} */

.modal .register .modal-body {
  padding: 0;
}

.modal .register .modal-content .comn-btn {
  width: 100%;
}

.modal .register .modal-content {
  padding: 30px 0px 0px;
  background: #11a5a9;
  box-shadow: 0px 20px 50px #11a5a9;
  border-radius: 30px;
}

.checkbox_wrapper {
  position: relative;
  height: 16px;
  width: 17px;
  margin-top: 8px;
}

input[type="checkbox"] {
  /* opacity: 0; */
  height: 16px;
  width: 17px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}

input[type="checkbox"] + label {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  border: 1px solid #47399b;
  border-radius: 5px;
}

input[type="checkbox"]:checked + label {
  background-image: none;
  background-repeat: no-repeat;
  height: 18px;
  width: 18px;
  display: inline-block;
  border: 1px solid #47399b;
  border-radius: 5px;
}

.modal .register .modal-content .close {
  padding: 6px 10px;
  margin: 0;
  background: #820103;
  border-radius: 50%;
}

.modal .register .modal-content .modal-header {
  border: none;
  border: none;
  padding: 0 30px 0;
}

.modal .register .modal-content .modal-body form .form-control:focus {
  border: 1px solid #04f0f6;
}

.modal .register .modal-content .modal-body form input {
  background: #350981;
  color: var(--body-color);
  border: 1px solid #47399b;
}

.modal .register .modal-content .modal-body form label {
  color: var(--body-color);
}

.modal .register .modal-content .modal-header button.btn-close {
  display: none;
}

.modal .register .modal-content .modal-body h5.welcome {
  width: 100%;
}

.modal .register .modal-content .modal-body h5 {
  /* text-transform: uppercase; */
  text-align: center;
  /* width: 35%; */
  margin: 0 auto;
  padding: 8px 0 6px;
  margin-bottom: 15px;
}

.modal .register .modal-content .modal-body p a {
  color: #04f0f6;
  text-transform: uppercase;
}

.modal .register .modal-content .modal-body p {
  text-align: center;
  margin: 0 0 37px;
}

.modal .register .modal-content .modal-body .form-area {
  padding: 30px 30px 30px 30px;
  background: #341211;
  border-radius: 30px;
}

.btnClose {
  width: 25px;
  margin:15px;
}

.modal .register .modal-content .modal-body .form-area .res_info {
  color: #fff;
  text-align: center;
}

.modal .register .modal-content .modal-body .form-group .check_span {
  margin-left: 16px;
  font-size: 13px;
  line-height: 18px;
  color: var(--body-color);
  font-weight: 400;
}

.modal .register .modal-content .modal-body .form-group .cmn-btn {
  margin-left: 0;
  width: 100%;
  margin-top: 25px;
}

.modal .register .modal-content .modal-body .form-group .cmn-btn:disabled {
  background-color: #382945;
}

.modal .register .modal-content .modal-body a.exchange-link {
  color: #04f0f6;
}

.modal .register .modal-content .modal-body .form-group .check_span span {
  color: #04f0f6;
  font-size: 13px;
  font-weight: inherit;
  line-height: inherit;
}

.modal .register .modal-content .modal-body .reg-with p {
  color: var(--body-color);
  text-transform: uppercase;
  margin-top: 35px;
}

.modal .register .modal-content .modal-body .reg-with .social-area a {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;
}

.modal .register .modal-content .modal-body .reg-with .social-area a img {
  z-index: 1;
}

.modal .register .modal-content .modal-body .reg-with .social-area a::before {
  position: absolute;
  content: "";
  z-index: 0;
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

.modal .register .modal-content .modal-body .reg-with .social-area a:hover::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

/* banner-section */
#banner-section {
  position: relative;
  padding-top: 167px;
  /* background-color: #141461; */
  /* background-image: url(../images/banner-bg.png); */
  background-size: 100%;
  background-repeat: no-repeat;
  margin-bottom: 60px;
}

#banner-section .main-content h1 {
  text-transform: uppercase;
  margin-bottom: 5px;
}

#banner-section .main-content h1 span {
  color: #04f0f6;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
}

#banner-section .main-content .cmn-btn {
  margin-top: 35px;
  margin-bottom: 20px;
}

#banner-section .banner-content .col-lg-12 {
  z-index: 3;
}

#banner-section .banner-content .ani-img {
  position: relative;
  top: -40%;
}

#banner-section .banner-content .ani-img img {
  position: absolute;
}

#banner-section .banner-content .ani-img .cir-1 {
  top: 0%;
  left: -15%;
  animation: ripple2Ani 4s linear infinite;
}

#banner-section .banner-content .ani-img .cir-2 {
  top: 200px;
  left: -35%;
  animation: ripple2Ani 3s linear infinite;
}

#banner-section .banner-content .ani-img .cir-3 {
  top: 0%;
  right: -15%;
  animation: rippleAni 4s linear infinite;
}

#banner-section .banner-content .ani-img .cir-4 {
  top: 200px;
  right: -35%;
  animation: rippleAni 3s linear infinite;
}

#banner-section .banner-content .ani-illu {
  position: relative;
  bottom: -35px;
  z-index: 0;
}

#banner-section .banner-content .ani-illu img {
  position: absolute;
}

#banner-section .banner-content .ani-illu .left-1 {
  left: 0;
  bottom: 0;
}

#banner-section .banner-content .ani-illu .right-2 {
  right: 0;
  bottom: 0;
}

#banner-section .banner-content .bottom-item {
  border-radius: 10px;
  background-color: #0d0d59;
  margin-bottom: -70px;
  z-index: 3;
  margin-right: 15px;
  margin-left: 15px;
}

#banner-section .banner-content .single-item {
  padding: 22px 0 26px;
}

#banner-section .banner-content .single-item .left-area {
  display: grid;
}

#banner-section .banner-content .single-item .left-area img {
  margin: 0 30px;
  max-width: inherit;
}

#banner-section .banner-content .single-item .right-area h4 {
  margin-bottom: 9px;
}

/* Home here */
#home-here {
}

#home-here .hero-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: top center;
  background-repeat: no-repeat;
  height: 800px;
  background-size: contain;
}

@media (max-width: 991px) {
  #home-here .hero-banner {
    background-position: center 50px;
  }
}


#home-here .hero-banner .bottom-area {
  padding-top: 380px;
}

#home-here .hero-banner .bottom-area h3 {
  text-transform: uppercase;
  margin: 20px 0 30px;
}

#home-here .hero-banner .bottom-area .prize-area {
  padding: 15px 0 10px;
  background: #370cbc;
  margin-bottom: 30px;
}

#home-here .hero-banner .bottom-area .bet-details {
  margin-bottom: 40px;
  padding: 0 15%;
  margin-top: 70px;
}

#home-here .hero-banner .bottom-area .bet-details h6,
#home-here .hero-banner .bottom-area .prize-area h6 {
  /* font-size: 13px; */
  line-height: 18px;
  text-transform: uppercase;
}

#home-here .hero-banner .bottom-area .prize-area .prize {
  margin-top: 10px;
}

#home-here .hero-banner .bottom-area .prize-area h5 {
  color: #04f0f6;
  font-weight: 700;
  margin-left: 5px;
}

#home-here .hero-banner .bottom-area .bet-details h5 {
  color: #04f0f6;
  text-transform: uppercase;
}

#home-here .hero-banner .bottom-area .bet-details h5 span {
  color: var(--body-color);
  text-transform: uppercase;
  font-size: inherit;
  font-family: inherit;
  font-weight: 700;
}

#home-here .hero-banner .bottom-area .draw-counter {
  border: 2px solid;
  border-image-source: linear-gradient(95.57deg, #ffffff -31.36%, #ffffff 159.29%);
  box-shadow: 0px 0px 44px 0px #7eebe84d;
  background: #00102b;
  padding: 10px 80px;
  /* background: #370cbc; */
  border-radius: 20px;
  display: inline-block;
  margin-bottom: -30px;
}

#home-here .hero-banner .bottom-area .draw-counter .time-parameter span {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: #04f0f6;
}

#home-here .hero-banner .bottom-area .draw-counter-new {
}

#home-here .hero-banner .bottom-area .draw-counter-new div {
}

#home-here .hero-banner .bottom-area .draw-counter-new .time-parameter span {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: #04f0f6;
}

/* Home here */
/* Feature Game */
#feature-game-section .single-item {
  padding: 0 15px;
}

#feature-game-section .container-fluid {
  margin-bottom: -12px;
}

#feature-game-section .container .right-area {
  margin-bottom: 15px;
}

/* Available Game */
#available-game-section {
  /* background-color: #0d0d48; */
}

#available-game-section .contained-area .col-lg-3 {
  margin-bottom: 30px;
}

#available-game-section .right-area .cmn-btn {
  margin-left: 5px;
}

/* Level Up */
#level-up-section {
  position: relative;
}

#level-up-section .right-area {
  display: grid;
}

#level-up-section .right-area .single-item {
  text-align: center;
}

#level-up-section .right-area .single-item h6 {
  margin-top: 30px;
  text-transform: uppercase;
}

/* Todays winner  */
#todays-winner-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#todays-winner-section.home .section-header {
  margin-bottom: 0;
}

#todays-winner-section .title-area {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

#todays-winner-section .title-area h5 {
  text-transform: uppercase;
  position: absolute;
  margin-top: 10px;
}

#todays-winner-section .winner-chart {
  background: rgba(104, 62, 254, 0.15);
  border: 1px solid #9180ff;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(39, 39, 138, 0.7);
  border-radius: 5px;
  padding: 8px 0;
  position: relative;
  overflow: hidden;
}

#todays-winner-section .winner-chart .ribbon {
  position: absolute;
  padding: 10px 50px;
  top: 20px;
  left: -55px;
  z-index: 1;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 14px;
  background: #1b5e42;
  color: #fff;
  transform: rotate(315deg);
  text-align: center;
}

#todays-winner-section .winner-chart .single-item {
  background-color: #292994;
  padding: 10px 30px;
  margin: 10px 15px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}

#todays-winner-section .winner-chart .single-item .left-area img {
  height: -moz-fit-content;
  height: fit-content;
}

#todays-winner-section .winner-chart .single-item .name-area img {
  background-color: #03d6f9;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 10px 0 15px;
}

#todays-winner-section .winner-chart .single-item .name-area h6 {
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
}

#todays-winner-section .winner-chart .single-item .win-price {
  background: #160d96;
  box-shadow: 0px 4px 8px rgb(12 23 80 / 80%);
  border-radius: 15px;
  padding: 5px 10px;
}

#todays-winner-section .winner-chart .single-item .win-price span {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: #00ff6d;
}

#todays-winner-section .winner-chart .single-item .win-price .cur {
  color: #fff;
  margin-right: 5px;
}

.fwinner-chart {
  width: 200px;
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 30px;
  right: -50px;
  font-size: 20px;
  color: rgb(255, 255, 255);
  z-index: 2;
  overflow: hidden;
  transform: rotate(45deg);
  border: 1px dashed;
  background: linear-gradient(45deg, #903eff 0%, #3e19ff 100%);
  box-shadow: 0 0 0 3px #903eff, 0px 21px 5px -18px #3f19ff60;
  text-align: center;
}

/* Counter Start */
#counter-section {
  /* background-color: #00003e; */
  margin-bottom: -8px;
}

#counter-section .single-item span {
  display: block;
  font-weight: bold;
  font-size: 32px;
  line-height: 38px;
  color: var(--body-color);
  margin: 12px 0 5px;
}

#counter-section .single-item .counter {
  display: inline-block;
}

#counter-section .single-item h6 {
  font-weight: bold;
  color: #03d6f9;
}

/* Latest Activites */
#latest-activites-section {
  position: relative;
}

#latest-activites-section.games {
  z-index: 1;
}

#latest-activites-section.games .ani-div .obj-1 {
  top: 0;
  left: 13%;
  animation: none;
}

#latest-activites-section::before {
  content: "";
  /* background-image: url(../images/latest-activites.png); */
  /* background-color: #141461; */
  opacity: 0.3;
  position: absolute;
  height: 100%;
  width: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#latest-activites-section .ani-div {
  opacity: 0.3;
  position: relative;
  z-index: -1;
}

#latest-activites-section .ani-div img {
  position: absolute;
}

#latest-activites-section .ani-div .obj-1 {
  top: -30px;
  left: 13%;
  animation: zoominout 4s infinite;
}

#latest-activites-section .ani-div .obj-2 {
  top: 125px;
  right: 4%;
  animation: zoominout 5s infinite;
}

#latest-activites-section .ani-div .obj-3 {
  top: 320px;
  left: 2%;
  animation: zoominout 5s infinite;
}

#latest-activites-section .nav-tabs {
  background: #171789;
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.1);
  border-radius: 28px;
  text-transform: uppercase;
  border: none;
}

#latest-activites-section .nav-tabs .nav-link {
  border: none;
  font-weight: 900;
  padding: 15px 30px;
  color: var(--body-color);
}

#latest-activites-section .nav-tabs .nav-link.active {
  background: #4e01ce;
  border-radius: 28px;
}

#latest-activites-section .tab-content {
  margin-bottom: -180px;
}

#latest-activites-section .table-responsive {
  background: linear-gradient(180deg, #1d0d80 0%, rgba(0, 0, 62, 0) 100%);
  padding: 30px 30px 0 30px;
}

#latest-activites-section .table {
  background-color: #141461;
  margin-bottom: 0;
}

#latest-activites-section .table th a {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
}

#latest-activites-section .table th img {
  width: 50px;
}

#latest-activites-section .table th,
#latest-activites-section .table td {
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #e7eaff;
  width: 0%;
  padding: 15px 10px;
  padding-left: 30px;
  vertical-align: middle;
}

#latest-activites-section .table thead tr th.text-start {
  text-align: start;
}

#latest-activites-section .table thead tr th {
  text-align: center;
  text-transform: uppercase;
}

#latest-activites-section .table thead tr {
  background: #252595;
  color: var(--body-color);
}

#latest-activites-section tbody tr img {
  /* margin-right: 5px; */
}

#latest-activites-section tbody tr {
  background: #141461;
  border-bottom: 1px solid #182280;
  border-top: 1px solid #182280;
  transition: all ease 0.3s;
}

#latest-activites-section tbody tr th {
  /* text-align: start !important; */
}

#latest-activites-section tbody tr td,
#latest-activites-section tbody tr th {
  text-align: center;
}

#latest-activites-section .table tbody tr:hover {
  background: #13136c;
  border-bottom: 1px solid #3f4aa9;
  border-top: 1px solid #3f4aa9;
  transition: all ease 0.3s;
}

/* FAQ Activites */
#faq-section .overlay {
  /* margin-top: 180px; */
}

#faq-section .overlay .section-header p {
  margin: auto 10%;
}

#faq-section .overlay .left-area {
  position: relative;
}

#faq-section .overlay .left-area,
#faq-section .overlay .left-area span {
  position: relative;
}

#faq-section .overlay .left-area span::before {
  content: "";
  position: absolute;
  background: #1c1b74;
  z-index: -5;
  border-radius: 50%;
  padding: 160px;
}

#faq-section .overlay .left-area span::after {
  content: "";
  position: absolute;
  background: #1c1b74;
  opacity: 0.5;
  z-index: -5;
  border-radius: 50%;
  padding: 210px;
  left: -15%;
  top: -15%;
  animation: zoominout 5s linear infinite;
}

#faq-section .overlay .left-area::before {
  content: "";
  position: absolute;
  background: #1c1b74;
  opacity: 0.3;
  z-index: -4;
  border-radius: 50%;
  padding: 240px;
  left: -24%;
  top: -23%;
  animation: zoominout 5s linear infinite;
}

#faq-section .overlay .left-area::after {
  content: "";
  position: absolute;
  background: #1c1b74;
  opacity: 0.2;
  z-index: -3;
  border-radius: 50%;
  padding: 265px;
  left: -32%;
  top: -31%;
  animation: zoominout 5s linear infinite;
}

#faq-section .overlay .card {
  border: none;
  margin-bottom: 20px;
}

#faq-section .overlay .card-header {
  background: #00102b;
  border: 2px solid #04f0f633;
  box-shadow: 0px 0px 15px 0px #7eebe833;
}

#faq-section .overlay .card-body {
  background-color: #000000;
  padding: 15px 30px 20px;
}

#faq-section .overlay .card-body p {
  font-size: 14px;
  line-height: 20px;
  color: #dce6ff;
}

#faq-section .overlay .card-header .btn-link {
  position: relative;
  color: #ffffff;
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-transform: uppercase;
}

#faq-section .overlay .card-header .btn-link::before {
  position: absolute;
  content: "";
  /* background-color: #016778; */
  right: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

#faq-section .overlay .card-header .collapsed.btn-link::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  height: 15px;
  width: 15px;
  right: 8px;
  transform: rotate(90deg);
  transition: all ease 0.3s;
}

#faq-section .overlay .card-header .btn-link::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  position: absolute;
  content: "";
  background-repeat: no-repeat;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  transform: rotate(0deg);
  transition: all ease 0.3s;
  right: 5px;
}

/* Footer Section */
#available-game-section.winners .tab-content .single-item {
  border: 5px solid #4e01ce;
  border-radius: 50%;
}

#available-game-section.winners .tab-content .single-item img {
  border-radius: 50%;
  display: block;
}

#available-game-section.winners .tab-content .single-item span {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  padding: 10px 25px;
  background: #4e01ce;
  border-radius: 14px;
  position: absolute;
}

/* Footer Section */
#footer-section {
  background: #00102b;
  border-top: 2px solid #04f0f633;
  box-shadow: 0px 0px 15px 0px #7eebe833;
  margin-top: 60px;
}

#footer-section .section-header {
  margin-top: -6px;
}

#footer-section .section-header p {
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
}

#footer-section .footer-top {
  background-color: #310e9e;
  margin-top: -260px;
  border-radius: 10px;
}

#footer-section .subscribe {
  background: #ffffff;
  border: 1px solid #4450b8;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 28px;
  padding: 5px;
  display: flex;
}

#footer-section .subscribe input {
  border: none;
  border-radius: 28px;
}

#footer-section .subscribe .btn {
  padding: 10px 20px;
  background: #4e01ce;
  border-radius: 28px;
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: var(--body-color);
  margin-right: 5px;
}

#footer-section .side-contant {
  position: relative;
}

#footer-section .side-contant img {
  position: absolute;
}

#footer-section .side-contant .left .bg {
  top: -40px;
}

#footer-section .side-contant .left .top {
  left: 10%;
}

#footer-section .side-contant .right img {
  right: 0;
  top: -12px;
}

#footer-section .navbar-collapse .main-menu li a {
  padding: 0px 25px;
  font-weight: 700;
}

#footer-section .bottom-area {
  padding-bottom: 30px;
}

#footer-section .bottom-area ul li a {
  text-transform: uppercase;
  padding: 0 15px;
}

#footer-section .bottom-area ul li a:hover {
  color: #04f0f6;
}

#footer-section .footer-bottom .main-content {
  padding: 30px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

#footer-section .footer-bottom .left-area p {
  font-size: 16px;
  line-height: 22px;
  text-transform: uppercase;
}

#footer-section .footer-bottom .left-area a {
  font-size: inherit;
  line-height: inherit;
  text-transform: uppercase;
  color: #04f0f6;
}

#footer-section .social-area a {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0 20px;
}

#footer-section .social-area a img {
  z-index: 1;
}

#footer-section .social-area a::before {
  position: absolute;
  content: "";
  z-index: 0;
  width: 30px;
  height: 30px;
  /* background-image: url(../images/social-bg.png); */
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

#footer-section .social-area a:hover::before {
  /* background-image: url(../images/social-bg-hover.png); */
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

#footer-section .footer-bottom .right-area .nice-select {
  border: 1px solid rgba(255, 255, 255, 0.2);
  height: 40px;
}

#footer-section .footer-bottom .right-area .nice-select .list {
  top: unset;
  bottom: 100%;
}

#footer-section .footer-bottom .right-area .nice-select span,
#footer-section .footer-bottom .right-area .nice-select ul li {
  text-transform: uppercase;
}

#footer-section .footer-bottom .right-area .nice-select span {
  padding: 0 15px 0 0;
}

#footer-section .main-menu {
  flex-direction: row;
}

#footer-section .footer-bottom .right-area .nice-select.open .list {
  background-color: #0d0d59;
}

#footer-section .footer-bottom .right-area .nice-select .option:hover,
#footer-section .footer-bottom .right-area .nice-select .option.focus,
#footer-section .footer-bottom .right-area .nice-select .option.selected.focus {
  background-color: transparent;
  color: #04f0f6;
}

/* Home Page Second  */
#banner-section.index-2 {
  background-image: unset;
}

#banner-section.index-2 .banner-content {
  position: relative;
}

#banner-section.index-2 .banner-content .banner-side {
  position: absolute;
  right: 5%;
}

#banner-section.index-2 .main-content .cmn-btn {
  margin-bottom: 0;
}

#banner-section.index-2 .banner-content .bottom-item {
  margin-bottom: -285px;
  margin-top: -10px;
}

.bottom-item .bottom-content {
  background: #0d0d59;
  border-radius: 10px 0px 0px 10px;
  padding: 80px 0;
}

.bottom-item .banner-carousel {
  margin: 0 0 15px;
}

.bottom-item .single-item {
  position: relative;
}

.bottom-item .single-item img {
  border-radius: 50%;
  display: block;
}

.bottom-item .single-item span {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding: 2px 8px;
  background: #4e01ce;
  border-radius: 14px;
  position: absolute;
  bottom: 15px;
  left: 10px;
}

.bottom-item .right-area h4 {
  text-transform: uppercase;
}

.bottom-item .right-area .couter-area {
  margin: 20px 0 40px;
}

.bottom-item .right-area h4 span {
  text-transform: uppercase;
  color: #04f0f6;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  background: #191961;
  border-radius: 5px;
  padding: 20px 15px;
  margin: -2px;
}

#available-game-section.index-2 {
  background-color: transparent;
}

#available-game-section.games-2.home-2 .overlay {
  margin-top: 245px;
}

#available-game-section.games-2.home-2 .overlay .menu-area {
  background: transparent;
}

#available-game-section.index-2 .nav-tabs {
  border: none;
}

#available-game-section.home-2.index-2 .cmn-btn-second {
  margin-top: 60px;
}

#available-game-section.home-2.index-2 .tab-content {
  margin: 0;
}

#available-game-section.index-2 .tab-content {
  margin: 60px 0;
}

#available-game-section.index-2 .nav-tabs .nav-item {
  margin-right: 10px;
}

#available-game-section.index-2 .input-area {
  padding: 4px 25px;
  background: #181868;
  border: 1px solid #4450b8;
  box-shadow: 0px 8px 24px rgb(0 0 0 / 10%);
  border-radius: 28px;
}

#available-game-section.index-2 .input-area input {
  background: #181868;
  color: var(--body-color);
  border: none;
  padding: 10px 20px;
}

/* Jackpot Section */
#jackpot-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

#jackpot-section .right-area {
  margin-top: -12px;
}

#jackpot-section .right-area h4 {
  text-transform: uppercase;
}

#jackpot-section .right-area .couter-area {
  margin: 39px 0 54px;
}

#jackpot-section .right-area h1 span {
  text-transform: uppercase;
  color: #04f0f6;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  padding: 20px 15px;
  margin: -5px;
}

#jackpot-section .right-area .cmn-btn-second {
  background-color: #7400d3;
  border: 1px solid #7400d3;
}

#jackpot-section .section-header {
  margin-bottom: 30px;
}

#jackpot-section .section-header h3 {
  text-transform: uppercase;
  margin-left: 20px;
}

#jackpot-section .jackpot-area {
  margin-bottom: -260px;
  z-index: 1;
}

#jackpot-section .carousel-jackpot .single-item {
  position: relative;
}

#jackpot-section .carousel-jackpot .single-item h6 {
  position: absolute;
  top: 20px;
  left: 35px;
  padding: 10px 30px;
  background: #4e01ce;
  border-radius: 10px;
}

#level-up-section.index-2 {
  margin-top: -20px;
  background-color: #00003e;
}

#jackpot-section .slick-initialized .slick-arrow {
  position: absolute;
  background-color: transparent;
  border-radius: 4px;
  padding: 2px 5px;
  line-height: 0;
  outline: none;
  transition: all 0.5s;
}

#jackpot-section .slick-initialized .slick-next {
  right: calc(8% - -10px);
  top: -20%;
  z-index: 1;
}

#jackpot-section .slick-initialized .slick-prev {
  right: calc(8% - 60px);
  top: -20%;
  z-index: 2;
}

#jackpot-section .slick-initialized .slick-next,
#jackpot-section .slick-initialized .slick-prev {
  background: #4e01ce;
  box-shadow: 0px 4px 0px #4707b3;
  border-radius: 28px;
  padding: 15px 30px;
  display: inline-block;
}

#jackpot-section .slick-initialized .slick-next:hover,
#jackpot-section .slick-initialized .slick-prev:hover {
  background: #7400d3;
  box-shadow: 0px 4px 0px #57049a;
}

#jackpot-section .slick-initialized .slick-prev::before,
#jackpot-section .slick-initialized .slick-next::before {
  content: "";
  height: 100px;
  width: 100px;
  position: absolute;
  top: 10px;
  left: 25px;
}

#jackpot-section .slick-initialized .slick-prev::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
}

#jackpot-section .slick-initialized .slick-next::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
}

/* Features Section */
#features-section {
  margin-bottom: -60px;
  margin-top: 60px;
}

#features-section .single-item .icon-area {
  width: 110px;
  height: 110px;
  background: #141461;
  border-radius: 55px;
  margin: 0 auto;
}

#features-section .single-item {
  margin-bottom: 60px;
}

#features-section .single-item h4 {
  text-transform: uppercase;
  margin: 40px 0 20px;
}

/* Counter Section */
#counter-section.index-2 .main-content {
  background: #1c1b74;
  padding: 40px 0;
}

#counter-section.index-2 .single-item h6 {
  margin-bottom: -5px;
}

/* Faq Section */
#faq-section.index-2 .overlay {
  margin: 0;
}

/* Inner Banner Section */
#banner-section.inner-banner h1 {
  text-transform: uppercase;
}

#banner-section.inner-banner .breadcrumb-area .breadcrumb {
  background: transparent;
}

#banner-section.inner-banner .breadcrumb-area ol {
  padding-left: 3px;
  margin-bottom: 45px;
}

#banner-section.inner-banner .breadcrumb-area ol li,
#banner-section.inner-banner .breadcrumb-area ol li a {
  font-size: 24px;
  line-height: 34px;
  font-weight: 400;
  color: var(--body-color);
}

.breadcrumb-item + .breadcrumb-item::before {
  padding-right: 20px;
  margin-top: 10px;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
}

/* Inner Section Games */
#banner-section.games {
  padding-top: 202px;
  padding-bottom: 78px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: 100% 100%;
  margin-bottom: 0;
}

#banner-section.games .banner-side {
  position: absolute;
  right: 0;
  bottom: 0;
}

#banner-section.hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: contain;
  background-position: top center;
  background-repeat: no-repeat;
  /* background-color: #12152E; */
  padding-top: 280px;
}

@media (max-width: 991px) {
  #banner-section.hero {
    padding-top: 130px;
    margin-top: 100px;
  }
}

/* Available Game */
#available-game-section.index-2.games {
  background: #0d0d48;
}

#available-game-section.index-2.games .overlay {
  margin-top: 0;
}

#available-game-section.index-2.games .tab-content {
  margin: 60px 0 0;
}

#available-game-section.games .overlay .menu-bar {
  background: #0e0e67;
  box-shadow: 0px 8px 12px #09093f;
  border-radius: 58px;
  padding: 15px;
}

#available-game-section.games .overlay .menu-bar .cmn-btn img {
  background: #6000ff;
  border-radius: 15px;
  padding: 5px;
}

#available-game-section.games .overlay .menu-bar .cmn-btn-alt:hover img {
  background: #8a0df0;
}

#available-game-section.games .overlay .menu-bar .active.cmn-btn img {
  background: #8a0df0;
}

#available-game-section.games .overlay .menu-bar .active.cmn-btn {
  background: #7400d3;
  box-shadow: 0px 4px 0px #7400d3;
}

/* Todays winner */
#todays-winner-section.games {
  background-image: unset;
  background-color: var(--body-bg);
}

#todays-winner-section.games .left-side {
  background: radial-gradient(78.16% 122.14% at 50% 54.76%, #fb0078 0%, #3e0b77 63.7%, #2f0c78 100%);
  border-radius: 20px;
  padding: 28px 0 59px;
}

#todays-winner-section.games .left-side .head {
  text-transform: uppercase;
  margin-bottom: 15px;
}

#todays-winner-section.games .left-side .profile {
  position: relative;
  display: inline-block;
  margin-top: 13px;
}

#todays-winner-section.games .left-side .profile img {
  border-radius: 50%;
  margin: 0 auto;
}

#todays-winner-section.games .left-side .profile h5 {
  background: #4e01ce;
  border-radius: 20px;
  position: absolute;
  bottom: -20px;
  transform: translate(-38px, 0px);
  width: 170px;
  padding: 6px 0;
}

#todays-winner-section.games .right-side {
  background: #480b96;
  border-radius: 30px;
  padding: 30px 39px 12px;
}

#todays-winner-section.games .winner-chart {
  background: transparent;
  border: none;
  box-shadow: none;
}

#todays-winner-section.games .winner-chart .single-item {
  padding: 25px 8px;
  background: #7818dd;
  border-radius: 10px;
}

#todays-winner-section.games .winner-chart .single-item .win-price {
  background: #480b96;
}

/* Lavel Up */
#level-up-section.games {
  margin-top: 60px;
}

/* Available Game */
#available-game-section.games-2 {
  background: var(--body-bg);
}

#available-game-section.games-2 .overlay {
  margin-top: 0;
}

#available-game-section.games-2 .overlay .menu-area {
  background: #0d0d48;
}

#available-game-section.games-2 .overlay .menu-bar {
  padding: 40px 0;
}

/* Feature Section */
#feature-section {
  margin-top: 60px;
}

#feature-section .overlay .single-item {
  padding: 20px;
  background: #0d0d46;
  border-radius: 10px;
}

#feature-section .overlay .single-item .img {
  width: 80px;
  height: 80px;
}

#feature-section .overlay .single-item .img-area {
  background: #141461;
  border-radius: 50px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
}

#feature-section .overlay .single-item .text-area h5 {
  text-transform: uppercase;
  margin-bottom: 20px;
}

/* Affiliate Program  */
#affiliate-program.game-2 {
  position: relative;
  background: #0d0d48;
}

#affiliate-program.game-2 .affiliate-illu {
  position: absolute;
  right: -10%;
  bottom: 0;
  max-width: 75%;
}

#affiliate-program.game-2 .section-header p {
  margin: 10px 0 30px;
}

#affiliate-program.game-2 .section-header h5 {
  font-family: var(--body-alt-font);
}

#affiliate-program.game-2 .section-header h5 span {
  color: #04f0f6;
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
}

/* Testimonial */
#testimonial .single-item {
  background: #0d0d48;
  border-radius: 20px;
  padding: 30px;
}

#testimonial .single-item .star i {
  color: #ffc107;
  margin: 0 -2px;
}

#testimonial .single-item h5 {
  text-transform: uppercase;
  margin: 25px 0 15px;
}

#testimonial .single-item .profile img {
  background: #03d6f9;
  border-radius: 50%;
  margin: 35px auto 20px;
}

#testimonial .single-item .profile h6 {
  text-transform: uppercase;
}

/* Tournaments Pages */
#banner-section.games.tournaments {
  background-image: unset;
}

#banner-section.games.tournaments .banner-left {
  position: absolute;
  left: 0;
  top: 0;
}

#banner-section.games.tournaments .banner-right {
  position: absolute;
  right: 0;
  top: 0;
}

#banner-section.games.tournaments .banner-right-illu {
  position: absolute;
  right: 0;
  top: -17%;
}

/* Tournaments Games */
#tournaments-games .menu-bar {
  background: #0e0e67;
  box-shadow: 0px 8px 12px #09093f;
  border-radius: 58px;
  padding: 15px;
}

#tournaments-games .nav-tabs {
  border: none;
}

#tournaments-games .nav-tabs .nav-item {
  margin-right: 10px;
}

#tournaments-games .nav-tabs .nav-item .cmn-btn.active {
  background: #7400d3;
  box-shadow: 0px 4px 0px #57049a;
}

#tournaments-games .input-area {
  padding: 4px 25px;
  background: #181868;
  border: 1px solid #4450b8;
  box-shadow: 0px 8px 24px rgb(0 0 0 / 10%);
  border-radius: 28px;
}

#tournaments-games .input-area input {
  background: #181868;
  color: var(--body-color);
  border: none;
  padding: 10px 20px;
}

#tournaments-games .tab-content .nice-select {
  background: #141448;
  border: 1px solid #4450b8;
  width: 100%;
  border-radius: 28px;
  padding: 7px 15px;
  height: 100%;
}

#tournaments-games .tab-content .nice-select:after {
  right: 15px;
}

#tournaments-games .tab-content .nice-select .list {
  background: #141448;
  border: 1px solid #4450b8;
  width: 100%;
}

#tournaments-games .nice-select .option:hover,
#tournaments-games .nice-select .option.focus,
#tournaments-games .nice-select .option.selected.focus {
  background-color: transparent;
  color: #03d6f9;
}

#tournaments-games .tab-pane .mb-cus {
  margin: 43px 0;
}

#tournaments-games .tab-pane i {
  background: #4e01ce;
  box-shadow: 0px 4px 0px #4707b3;
  border-radius: 10px;
  padding: 19px;
  color: var(--body-color);
  margin-left: 10px;
  cursor: pointer;
}

#tournaments-games .tab-pane i.active {
  background: #7400d3;
  box-shadow: 0px 4px 0px #57049a;
}

#tournaments-games .tab-content .all-items {
  width: 100% !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

#tournaments-games .tab-content .single-item {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% / 2 - 15px);
  -ms-flex: 0 0 calc(100% / 2 - 15px);
  max-width: calc(100% / 2 - 15px);
  padding: 30px 20px;
  border: 1px solid #262975;
  border-radius: 20px;
  margin-bottom: 30px;
  transition: all ease 0.5s;
}

#tournaments-games .tab-content .single-item .cmn-btn-second {
  border: 1px solid #4450b8;
}

#tournaments-games .tab-content .single-item .cmn-btn-second:hover {
  background: #4450b8;
}

#tournaments-games .tab-content .single-item.list {
  justify-content: space-between;
  display: flex;
  position: relative;
  transition: all ease 0.5s;
}

#tournaments-games .tab-content .single-item.list:after {
  position: absolute;
  content: "";
  width: 1px;
  height: 80%;
  border: 1px solid #293574;
  right: calc(37% - 0px);
  top: 10%;
}

#tournaments-games .tab-content .single-item .content-area {
  display: flex;
}

#tournaments-games .tab-content .single-item.list .grid-style {
  text-align: start;
  margin: 0 30px;
}

#tournaments-games .tab-content .single-item .grid-style {
  margin: 0 auto;
  display: grid;
  align-items: center;
  text-align: center;
}

#tournaments-games .tab-content .single-item .grid-style h5 {
  text-transform: uppercase;
}

#tournaments-games .tab-content .single-item .grid-style .prize {
  padding: 15px 30px;
  background: #191951;
  border-radius: 10px;
}

#tournaments-games .tab-content .single-item .grid-style .prize img {
  margin-right: 5px;
}

#tournaments-games .tab-content .single-item .grid-style .prize h5 {
  color: #04f0f6;
}

#tournaments-games .tab-content .single-item .grid-style .bet {
  text-transform: uppercase;
  font-size: 16px;
  line-height: 22px;
}

#tournaments-games .tab-content .single-item .grid-style .bet span {
  color: #04f0f6;
  font-size: inherit;
  line-height: inherit;
}

#tournaments-games .tab-content .single-item .list-right {
  display: none;
}

#tournaments-games .tab-content .single-item.list .list-right {
  display: grid;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background: #090944;
  border-radius: 20px;
}

#tournaments-games .tab-content .single-item.list .list-right .draw-counter .date-area span {
  display: inline-block;
}

#tournaments-games .tab-content .single-item.list .list-right .draw-counter .time-parameter span {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  color: #03d6f9;
  margin: 0 4px;
}

#tournaments-games .tab-content .single-item.list .list-right .end-on,
#tournaments-games .tab-content .single-item .grid-style .end-on {
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
}

#tournaments-games .tab-content .single-item.list .list-right .end-on span,
#tournaments-games .tab-content .single-item .grid-style .end-on span {
  color: #04f0f6;
  font-size: inherit;
  line-height: inherit;
}

#tournaments-games .tab-content .single-item.list {
  flex: 0 0 100%;
  -ms-flex: 0 0 100%;
  max-width: 100%;
}

#tournaments-games .tab-content .single-item.list .grid-style .cmn-btn-second,
#tournaments-games .tab-content .single-item.list .grid-style .end-on {
  display: none;
}

.hero-banner {
  /* background-image: url(../images/tournament/x50-hero.webp); */
  padding-top: 100px;
  padding-bottom: 200px;
  background-position: center;
  background-repeat: no-repeat;
  background-color: black;
}

/* Tournaments Details */
#banner-section.tourn-details {
  padding-bottom: 0;
}

#banner-section.tourn-details .wi-100 {
  width: 110%;
}

#banner-section.tourn-details .bottom-area {
  background: #310e9e;
  border-radius: 20px;
  padding: 40px 0 0;
  /* margin-bottom: -250px; */
}

#banner-section.tourn-details .bottom-area h3 {
  text-transform: uppercase;
  margin: 20px 0 30px;
}

#banner-section.tourn-details .bottom-area .prize-area {
  padding: 15px 0 10px;
  background: #370cbc;
  margin-bottom: 30px;
}

#banner-section.tourn-details .bottom-area .bet-details {
  margin-bottom: 40px;
  padding: 0 15%;
}

#banner-section.tourn-details .bottom-area .bet-details h6,
#banner-section.tourn-details .bottom-area .prize-area h6 {
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
}

#banner-section.tourn-details .bottom-area .prize-area .prize {
  margin-top: 10px;
}

#banner-section.tourn-details .bottom-area .prize-area h5 {
  color: #04f0f6;
  font-weight: 700;
  margin-left: 5px;
}

#banner-section.tourn-details .bottom-area .bet-details h5 {
  color: #04f0f6;
  text-transform: uppercase;
}

#banner-section.tourn-details .bottom-area .bet-details h5 span {
  color: var(--body-color);
  text-transform: uppercase;
  font-size: inherit;
  font-family: inherit;
  font-weight: 700;
}

#banner-section.tourn-details .bottom-area .draw-counter {
  padding: 10px 80px;
  background: #370cbc;
  border-radius: 20px;
  display: inline-block;
  margin-bottom: -30px;
}

#banner-section.tourn-details .bottom-area .draw-counter .time-parameter span {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: #04f0f6;
}

#banner-section.games.tourn-details .banner-content .banner-right-illu {
  position: absolute;
  right: 3%;
  bottom: 0;
  top: unset;
}

/* Tournament Start */
#tournament-section {
  background: #0d0d48;
}

#tournament-section .section-header {
  margin-top: -12px;
  margin-bottom: 30px;
}

#tournament-section .section-header h3 {
  text-transform: uppercase;
}

#tournament-section .single-item img {
  width: 100%;
}

#tournament-section .slick-initialized {
  margin-bottom: -4px;
}

#tournament-section .slick-initialized .slick-arrow {
  position: absolute;
  background-color: transparent;
  border-radius: 4px;
  padding: 2px 5px;
  line-height: 0;
  outline: none;
  transition: all 0.5s;
}

#tournament-section .slick-initialized .slick-next {
  right: calc(8% - -10px);
  top: -75px;
  z-index: 1;
}

#tournament-section .slick-initialized .slick-prev {
  right: calc(8% - 60px);
  top: -75px;
  z-index: 2;
}

#tournament-section .slick-initialized .slick-next,
#tournament-section .slick-initialized .slick-prev {
  width: 40px;
  height: 40px;
  background: #4e01ce;
  box-shadow: 0px 4px 0px #4707b3;
  border-radius: 10px;
  display: inline-block;
}

#tournament-section .slick-initialized .slick-next:hover,
#tournament-section .slick-initialized .slick-prev:hover {
  background: #7400d3;
  box-shadow: 0px 4px 0px #7400d3;
}

#tournament-section .slick-initialized .slick-prev::before,
#tournament-section .slick-initialized .slick-next::before {
  content: "";
  height: 100px;
  width: 100px;
  position: absolute;
  top: 13px;
  left: 13px;
}

#tournament-section .slick-initialized .slick-prev::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
}

#tournament-section .slick-initialized .slick-next::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
}

/* Tournaments Prize */
#tournaments-prize .price-rest {
  background: #00102b;
  border: 2px solid #04f0f633;
  box-shadow: 0px 0px 15px 0px #7eebe833;
  margin-top: 40px;
  padding: 20px;
  border-radius: 20px;
  text-align: center;
}

#tournaments-prize .price-rest h4 {
  color: #04f0f6;
}

#tournaments-prize .price-rest p.small {
  margin-top: 10px;
}

#tournaments-prize .first-item {
}

@media (max-width: 991px) {
  #tournaments-prize .first-item img {
    height:350px;
  }
}

#tournaments-prize .first-item .info {
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 45px 0px #ffffff99;
  padding: 20px 52px 30px 52px;
  border-radius: 20px;
}

#tournaments-prize .first-item h6 {
  color: #04f0f6;
}
 
#tournaments-prize .single-item {
  position: relative;
  background: #00102b;
  border: 2px solid #04f0f633;
  box-shadow: 0px 0px 15px 0px #7eebe833;
  border-radius: 20px;
  padding: 40px 0;
}

#tournaments-prize .single-item::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  /* background: url(../images/prize-trophy-bg.png); */
  background-repeat: no-repeat;
  border-radius: 20px;
  left: 0;
  top: 0;
}

#tournaments-prize .single-item img {
  width: 50%;
}

#tournaments-prize .single-item h6 {
  color: #04f0f6;
  margin: 20px 0 15px;
}

#tournaments-prize .cmn-btn {
  margin-top: 60px;
  border-radius: 10px;
}

#tournaments-prize .modal-content {
  background: #19084d;
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
}

#tournaments-prize .modal-body {
  padding-bottom: 30px;
}

#tournaments-prize .modal-content .cmn-btn {
  margin-top: 30px;
  font-size: 13px;
  line-height: 18px;
}

#tournaments-prize .modal-header {
  border: none;
}

#tournaments-prize .table {
  background: #310e9e;
  box-shadow: 0px 1px 0px #261687;
  width: 99%;
}

#tournaments-prize thead th {
  color: var(--body-color);
  text-align: center;
}

#tournaments-prize tbody tr img {
  margin-right: 10px;
}

#tournaments-prize tbody tr {
  background: #31148b;
  border: 1px solid #2f3998;
}

#tournaments-prize tbody tr td,
#tournaments-prize tbody tr th {
  color: var(--body-color);
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

#tournaments-prize .table tbody tr:hover {
  background: #13136c;
  border-bottom: 1px solid #3f4aa9;
  border-top: 1px solid #3f4aa9;
  transition: all ease 0.3s;
}

/* tournament my information */
#tournament-my-information .my-info {
  padding: 30px 20px;
  background: #00102b;
  border: 2px solid #04f0f633;
  box-shadow: 0px 0px 15px 0px #7eebe833;
  border-radius: 20px;
}

#tournament-my-information .my-info .plus {
  color: #04f0f6;
}

#tournament-my-information .my-info .minus {
  color: #990e60;
}

/* leaderboard prize */
#leaderboard-prize {
  /* background: #220970; */
  /* background-image: url(../images/leaderboard-bg.png); */
  /* background-repeat: no-repeat; */
  /* background-size: 100% 100%; */
  /* margin-top: -390px; */
}

#leaderboard-prize .overlay {
  /* transform: translateY(400px); */
}

#leaderboard-prize .table-responsive {
  border: 2px solid #04f0f6;
  box-shadow: 0px 0px 44px 0px #7eebe84d;
  border-radius: 16px;
}

#leaderboard-prize .table {
  /* background: #310e9e; */
  /* box-shadow: 0px 1px 0px #261687; */
  /* width: 99%; */
  /* border: 2px solid #04F0F6;
  box-shadow: 0px 0px 44px 0px #ff4d1666;
  border-radius: 16px; */
  margin-bottom: 0;
}

#leaderboard-prize thead th {
  background: #00102b;
  color: var(--body-color);
  text-align: center;
  padding: 20px 10px;
}

#leaderboard-prize tbody tr img {
  /* margin-right: 10px; */
  max-width: 50px;
}

#leaderboard-prize tbody tr {
  background: #00102b;
  border-top: 1px solid #ffb85c1a;
  border-bottom: 1px solid #ffb85c1a;
}

#leaderboard-prize tbody tr td a {
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
}

#leaderboard-prize tbody tr td,
#leaderboard-prize tbody tr th {
  color: var(--body-color);
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

#leaderboard-prize span.rank {
  border-radius: 50px;
  background: #00102b;
  width: 50px;
  height: 50px;
  padding-top: 10px;
}

#leaderboard-prize span.rank-1 {
  border: 3px solid #ffad2a;
}

#leaderboard-prize span.rank-2 {
  border: 3px solid #b2e1eb;
}

#leaderboard-prize span.rank-3 {
  border: 3px solid #af591d;
}

#leaderboard-prize .table tbody tr:hover {
  /* background: #13136c; */
  /* border-bottom: 1px solid #3f4aa9; */
  /* border-top: 1px solid #3f4aa9; */
  transition: all ease 0.3s;
}

#leaderboard-prize .cmn-btn {
  margin-top: 35px;
  border-radius: 10px;
}

#feature-section.tourn-details {
  margin-top: 255px;
}

/* About Us */
#banner-section.about {
  padding-top: 202px;
  padding-bottom: 0;
  background-image: unset;
}

#banner-section .banner-bottom.about {
  z-index: 1;
  margin-top: -450px;
}

#banner-section .banner-bottom.about .main-content {
  position: relative;
  transform: translateY(480px);
}

#banner-section .banner-bottom.about .main-content::before {
  position: absolute;
  content: "";
  background: #0d0d48;
  border-radius: 20px;
  width: 115%;
  height: 80%;
  left: -5%;
  z-index: -1;
}

#banner-section .banner-bottom.about .item-area {
  transform: translate(30px, -80px);
}

#banner-section .banner-bottom.about .item-area .content-item {
  padding: 30px;
  background-color: #31148b;
  border-radius: 20px;
}

#banner-section .banner-bottom.about .item-area .single-item {
  padding: 0;
  width: 85%;
  margin: 0 auto;
}

#banner-section .banner-bottom.about .item-area .single-item h2 {
  font-weight: bold;
  text-transform: uppercase;
  color: #04f0f6;
}

/* story behind gainio */
#story-behind-gainio {
  margin-top: 387px;
  background-color: var(--body-bg);
}

#story-behind-gainio h2 {
  text-transform: uppercase;
}

#story-behind-gainio p {
  margin: 30px 0 34px;
}

#story-behind-gainio .btn-area a {
  border-radius: 10px;
  font-size: 13px;
  line-height: 18px;
  padding: 12px 18px;
  margin: 0 15px;
}

/* Leading brand */
#leading-brand {
  background-color: #0d0d48;
}

#leading-brand .overlay {
  position: relative;
}

#leading-brand .bg-right {
  position: absolute;
  right: -20%;
}

#leading-brand .single-item {
  padding: 20px;
  border: 1px solid #31148b;
  border-radius: 10px;
  margin-bottom: 30px;
}

#leading-brand .single-item .text-area h5 {
  text-transform: uppercase;
}

#leading-brand .left-side .img-area {
  width: 80px;
  height: 80px;
  background: #3b13b6;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

/* Team member */
#team-member .single-item {
  margin-bottom: 7px;
}

#team-member .single-item .img-area {
  background: #03d6f9;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  margin: 0 auto;
  overflow: hidden;
}

#team-member .single-item .img-area img {
  border-radius: 50%;
  margin-top: 7px;
}

#team-member .single-item .bottom-area h5 {
  text-transform: uppercase;
  margin: 24px 0 30px;
  text-align: center;
}

#team-member .social-area a {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 15px;
}

#team-member .social-area a img {
  z-index: 1;
}

#team-member .social-area a::before {
  position: absolute;
  content: "";
  z-index: 0;
  width: 30px;
  height: 30px;
  /* background-image: url(../images/social-bg.png); */
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

#team-member .social-area a:hover::before {
  /* background-image: url(../images/social-bg-hover.png); */
  background-repeat: no-repeat;
  transition: ease 0.5s;
}

/* FAQ Section  */
#faq-page.faq .nav-tabs {
  border: none;
  display: flex;
  justify-content: center;
}

#faq-page.faq .nav-tabs .nav-item {
  margin: 0 10px;
}

#faq-page.faq .nav-tabs .nav-item .cmn-btn {
  border-radius: 10px;
  border: none;
  background: #4e01ce;
  box-shadow: 0px 4px 0px #4707b3;
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
  color: var(--body-color);
  padding: 20px 40px;
}

#faq-page.faq .nav-tabs .nav-item .cmn-btn.active {
  background: #7400d3;
  box-shadow: 0px 4px 0px #57049a;
}

#faq-page.faq .tab-content {
  margin-bottom: -20px;
}

#faq-page.faq .tab-content .tab-pane h4 {
  text-transform: uppercase;
  text-align: center;
  margin: 40px 0 35px;
}

#faq-page.faq .card {
  border: none;
  margin-bottom: 20px;
}

#faq-page.faq .card-header {
  background-color: #1c1b74;
}

#faq-page.faq .card-body {
  background-color: #08074c;
  padding: 15px 30px 20px;
}

#faq-page.faq .card-header .btn-link {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: start;
  text-decoration: none;
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-transform: uppercase;
}

#faq-page.faq .card-header .btn-link::before {
  position: absolute;
  content: "";
  background-color: #016778;
  right: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

#faq-page.faq .card-header .collapsed.btn-link::after {
  position: absolute;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  height: 15px;
  width: 15px;
  right: 8px;
  transform: rotate(90deg);
  transition: all ease 0.3s;
}

#faq-page.faq .card-header .btn-link::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  position: absolute;
  content: "";
  background-repeat: no-repeat;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  transform: rotate(0deg);
  transition: all ease 0.3s;
  right: 5px;
}

.text-content h3 {
  margin-top: 40px;
}

#index-announcement {
}

#index-announcement .info {
  background-color: #141461;
  margin-top: 40px;
  padding: 20px;
  border-radius: 20px;
  text-align: center;
}

.countdown {
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 44px 0px #7eebe84d;
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #00102b;
  color: white;
  border-radius: 5px;
}

.countdown .counter {
  display: flex;
}

@media (max-width: 400px) {
  .time-unit {
    padding: 5px!important;
  }
  .countdown-button-text {
    font-size: smaller; 
    text-align: center;
    line-height: 1.2; 
  }
  .countdown .countdown-button {
    padding-top:10px!important;
    padding-bottom:10px!important;
  }

}

.countdown .time-unit {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 35px;
  font-weight: bold;
}

.countdown .time-unit .number {
  font-size: 24px;
}

.countdown .time-unit .label {
  font-size: 22px;
  color: #ffffffcc;
  margin-left: 5px;
}

.countdown .ttl {
  text-transform: uppercase;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 18px;
  margin-left: 15px;
  font-weight: bold;
}

.countdown .countdown-button {
  background-color: #00ccff;
  color: white;
  padding: 10px 20px;
  font-size: 1em;
  margin-left: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
}

.countdown .countdown-button a {
  text-transform: uppercase;
  text-decoration: none;
  text-shadow: 0 0 1px #0039ff, 0 0 2px #00ccff;
}

@media (max-width: 991px) {
  .countdown .countdown-button a {
    font-size: 20px;
  }
}

.modal .modal-giveaway h6 {
  color: #000000;
}

.modal .modal-giveaway img {
  border-radius: 10px;
}

.modal .modal-giveaway .modal-body {
  padding: 0;
}

.modal .modal-giveaway .modal-content .comn-btn {
  width: 100%;
}

.modal .modal-giveaway .modal-content {
  background: #11a5a9;
  box-shadow: 0px 20px 50px #11a5a9;
  border-radius: 30px;
}

.modal .modal-giveaway .modal-header .btn-close {
  display: none;
}
.modal .modal-giveaway .modal-header {
  position: absolute;
  top: -50;
  z-index: 1;
  border: none;
}

/* .modal .modal-giveaway .modal-content {
  background-image: url(../images/banners/giveaway-banner.jpg);
  background-repeat: no-repeat;
  background-position: center center;
} */

/* responsive area */
@media (min-width: 1200px) and (max-width: 1700px) {
  #banner-section .banner-bottom.about .main-content::before {
    width: 96%;
    height: 80%;
    left: 5%;
  }
  #banner-section.index-2 .banner-content .banner-side {
    right: -15%;
  }
}

@media (min-width: 991px) and (max-width: 1269.98px) {
  #level-up-section .right-area .single-item img {
    width: 70%;
  }
}

@media (max-width: 1199px) {
  .cmn-btn {
    padding: 12px 20px;
  }
  #banner-section .banner-content .bottom-item {
    margin-right: 0;
    margin-left: 0;
  }
  #banner-section .main-content {
    padding-bottom: 0;
  }
  .navbar-collapse .main-menu li a {
    padding: 40px 12px;
    font-weight: 800;
    font-family: var(--body-font);
    font-size: 18px;
    text-transform: capitalize;
  }
  #leading-brand .bg-right {
    right: -15%;
    width: 45%;
  }
  #banner-section .banner-bottom.about .item-area {
    transform: translate(0, -80px);
  }
  #banner-section .banner-bottom.about .main-content::before {
    width: 82%;
    height: 80%;
    left: 9%;
  }
  #banner-section .banner-bottom.about .item-area .single-item {
    width: 100%;
  }
  #faq-page.faq .nav-tabs .nav-item .cmn-btn {
    padding: 16px 30px;
  }
  #available-game-section.games .overlay .menu-bar .cmn-btn {
    padding: 12px 12px;
  }
  #available-game-section.games .overlay .menu-bar .cmn-btn {
    padding: 12px 12px;
  }
  #feature-section .overlay .single-item .img-area {
    margin-right: 10px;
    width: 75px;
    height: 75px;
  }
  #banner-section.index-2 .banner-content .banner-side {
    right: -18%;
    width: 55%;
  }
  #jackpot-section .right-area h1 span {
    margin: -8px;
  }
  #banner-section .banner-bottom.about .main-content .ban-img {
    width: 80%;
  }
  #banner-section .banner-bottom.about .main-content {
    text-align: center;
  }
}

@media (max-width: 991px) {
  h1,
  h1 > a {
    font-size: 54px;
    line-height: 64px;
  }
  h2,
  h2 > a {
    font-size: 40px;
    line-height: 47px;
  }
  h3,
  h3 > a {
    font-size: 30px;
    line-height: 36px;
  }
  h4,
  h4 > a {
    font-size: 24px;
    line-height: 28px;
  }
  h5,
  h5 > a {
    font-size: 18px;
    line-height: 22px;
  }
  h6,
  h6 > a,
  a,
  p,
  span,
  li,
  .cmn-btn,
  table thead tr th {
    font-size: 14px;
    line-height: 20px;
  }
  .section-header {
    margin-bottom: 30px;
  }
  #header-section .navbar .navbar-nav .menu_has_children::after {
    display: none;
  }
  .navbar-collapse .main-menu li a {
    padding: 15px 12px;
  }
  #banner-section .banner-content .bottom-area img {
    max-width: 70%;
  }
  #banner-section .banner-content .ani-illu img {
    width: 25%;
  }
  #available-game-section .section-header {
    width: 120%;
  }
  #available-game-section .right-area {
    text-align: end;
  }
  #available-game-section .right-area .cmn-btn:first-child {
    margin-bottom: 20px;
  }
  #available-game-section .contained-area {
    margin-top: 30px;
  }
  #level-up-section .section-header {
    margin-top: 60px;
  }
  #header-section .right-area .lang {
    display: none !important;
  }
  #todays-winner-section .mid-area .jus-end {
    justify-content: flex-end !important;
    -ms-flex-align: flex-end !important;
  }
  #todays-winner-section .title-area {
    margin-top: 60px;
  }
  #latest-activites-section .nav-tabs .nav-link {
    font-weight: 700;
    padding: 12px 20px;
  }
  #latest-activites-section .table {
    width: 170%;
  }
  #latest-activites-section .table th,
  #latest-activites-section .table td {
    width: 0;
  }
  #level-up-section .left-area {
    justify-content: center;
  }
  #faq-section .cus-mb {
    justify-content: center;
    margin: 100px 0 130px;
  }
  #footer-section .side-contant .right img {
    right: 0;
    top: -65px;
  }
  #footer-section .side-contant .left .bg {
    top: -10px;
    width: 40%;
  }
  #footer-section .subscribe input {
    font-size: 14px;
    padding: 10px 14px;
  }
  #footer-section .footer-bottom .left-area p {
    font-size: 14px;
    line-height: 20px;
  }
  #latest-activites-section.games .ani-div .obj-1 {
    display: none;
  }
  #jackpot-section .slick-initialized .slick-prev,
  #jackpot-section .slick-initialized .slick-next {
    top: -30%;
  }
  #banner-section.games.tournaments.faq .banner-left {
    width: 35%;
  }
  #banner-section.games.tournaments.faq .banner-right {
    width: 40%;
  }
  #banner-section.games.faq {
    padding-bottom: 35px;
  }
  #tournament-section .overlay {
    margin-top: 140px;
  }
  #leaderboard-prize {
    background-size: 100% 118%;
    /* margin-top: -390px; */
  }
  #feature-section.tourn-details {
    margin-top: 345px;
  }
  #footer-section .side-contant .left .top {
    left: 10%;
    top: 0;
    width: 13%;
  }
  #footer-section .side-contant .right img {
    right: 0;
    bottom: 0;
    width: 34%;
    top: 80px;
  }
  #banner-section.games.tournaments .banner-right-illu {
    right: -20%;
    top: 0;
    width: 50%;
    bottom: 0;
  }
  #banner-section.home-2 .bottom-item .bottom-content {
    padding: 40px 24px;
  }
  #banner-section.home-2 .bottom-item .right-area {
    margin-top: 60px;
  }
  #faq-section .overlay .left-area span::after,
  #faq-section .overlay .left-area::after,
  #faq-section .overlay .left-area::before {
    animation: none;
  }
  #banner-section .banner-bottom.about .main-content::before {
    width: 100%;
    height: 70%;
    left: 0%;
  }
  #banner-section .banner-bottom.about .item-area .single-item {
    width: 85%;
  }
  #leading-brand .bg-right {
    right: -30%;
    width: 45%;
  }
  #faq-page.faq .tab-content .tab-pane h4 {
    margin: 30px 0 30px;
  }
  #available-game-section.index-2 .nav-tabs {
    border: none;
    margin-top: 18px;
  }
  #todays-winner-section.games .right-side {
    padding: 4px 0 10px;
  }
  #todays-winner-section.games .left-side {
    margin-bottom: 30px;
  }
  #tournaments-games .nav-tabs .nav-item {
    margin: 5px;
    margin-right: initial;
  }
  #tournaments-games .tab-pane .mb-cus {
    margin: 30px 0;
    justify-content: space-around;
  }
  #tournaments-games .tab-content .single-item.list .content-area {
    display: flex;
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item .content-area {
    display: grid;
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item .grid-style .head-area {
    margin: 12px 0;
  }
  #tournaments-games .tab-content .single-item .grid-style .bet {
    margin: 15px 0;
  }
  #tournaments-games .tab-content .single-item .cmn-btn-second {
    margin-bottom: 15px;
  }
  #level-up-section.games {
    margin-top: 110px;
  }
  #available-game-section.index-2.games-2 .nav-tabs {
    border: none;
    margin-top: 18px;
    justify-content: center;
    margin-bottom: 25px;
  }
  #affiliate-program.game-2 .affiliate-illu {
    position: absolute;
    right: -10%;
    bottom: 0;
    max-width: 45%;
  }
  #feature-section {
    margin-top: 110px;
  }
  #feature-section .overlay .single-item {
    margin-bottom: 20px;
  }
  #feature-section .overlay .row {
    margin-bottom: -20px;
  }
  #testimonial .single-item {
    padding: 15px 7px;
  }
  .bottom-item .bottom-content {
    padding: 60px 24px;
  }
  #level-up-section.index-2 {
    margin-top: 50px;
  }
  #jackpot-section {
    padding-bottom: 90px;
  }
  #features-section {
    margin-top: 120px;
  }
  #counter-section .single-item {
    margin-top: 30px;
    padding-bottom: 30px;
  }
  #counter-section.index-2 .main-content {
    padding-top: 0;
    padding-bottom: 10px;
  }
  #banner-section.index-2 .banner-content .banner-side {
    display: none;
  }
}

@media (max-width: 767px) {
  .justify-cen {
    justify-content: center !important;
  }
  #banner-section .banner-content .ani-img img {
    width: 30%;
  }
  #banner-section .banner-content .single-item {
    align-items: center;
  }
  .section-header {
    margin-top: -12px;
    margin-bottom: 30px;
  }
  .cmn-btn {
    padding: 10px 15px;
  }
  #available-game-section .section-header {
    text-align: center;
  }
  #available-game-section .section-header {
    width: initial;
  }
  #latest-activites-section .section-header {
    text-align: center;
  }
  #latest-activites-section .nav-tabs {
    margin-bottom: 30px;
  }
  #latest-activites-section .table {
    width: 240%;
  }
  #footer-section .side-contant {
    display: none;
  }
  #footer-section .social-area {
    margin-top: 50px;
  }
  #footer-section .order-pro {
    order: 1;
  }
  #footer-section .footer-bottom .left-area p {
    margin-top: 20px;
  }
  #footer-section .bottom-area ul li a {
    padding-left: 15px;
  }
  #banner-section.games.faq {
    padding-bottom: 15px;
  }
  #banner-section .banner-bottom.about .item-area .content-item {
    padding: 20px;
  }
  #banner-section .banner-bottom.about .item-area .single-item {
    width: 100%;
  }
  #banner-section.games .banner-side {
    right: 2%;
    bottom: 6%;
    width: 50%;
  }
  #banner-section.about {
    padding-top: 150px;
    padding-bottom: 50px;
    background-image: unset;
  }
  #banner-section .banner-bottom.about .main-content {
    position: relative;
    transform: translateY(420px);
  }
  #tournament-section .overlay {
    margin-top: 200px;
  }
  #banner-section.games.tournaments .banner-right-illu {
    right: -20%;
    top: 0;
    width: 0;
    bottom: 0;
  }
  #banner-section.games.tournaments .banner-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 60%;
  }
  #jackpot-section .slick-initialized .slick-next,
  #jackpot-section .slick-initialized .slick-prev {
    top: -40%;
  }
  #faq-section .cus-mb {
    margin: 55px 0 80px;
  }
  #available-game-section.home-2.index-2 .nav-tabs {
    display: flex;
  }
  #banner-section.home-2 {
    padding-top: 90px;
  }
  #tournaments-games .tab-pane .mb-cus .md-none {
    display: none !important;
  }
  #tournaments-games .tab-content .nice-select {
    padding: 7px 8px;
  }
  #tournaments-games .nav-tabs {
    margin-top: 10px;
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item.list {
    display: grid;
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item.list .content-area {
    display: grid;
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item.list .grid-style {
    text-align: center;
    margin: 0 30px;
  }
  #tournaments-games .tab-content .single-item.list:after {
    border: 0;
  }
  #tournaments-games .tab-content .single-item,
  #tournaments-games .tab-content .single-item.list {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 2 - 15px);
    -ms-flex: 0 0 calc(100% / 2 - 15px);
    max-width: calc(100% / 2 - 15px);
    padding: 15px 10px;
  }
  #tournaments-games .tab-content .single-item.list .content-area img {
    width: 100%;
  }
  #tournaments-games .tab-content .single-item.list .list-right {
    padding: 10px;
  }
  #tournaments-games .tab-content .single-item.list .list-right .draw-counter {
    margin: 10px 0;
  }
  #story-behind-gainio {
    margin-top: 280px;
    background-color: var(--body-bg);
  }
  #team-member .mb-cus {
    margin-bottom: -55px;
  }
  #team-member .single-item {
    margin-bottom: 55px;
  }
  #banner-section.inner-banner .breadcrumb-area ol li,
  #banner-section.inner-banner .breadcrumb-area ol li a {
    font-size: 18px;
  }
  #faq-page.faq .nav-tabs .nav-item .cmn-btn {
    padding: 10px 13px;
  }
  #faq-page.faq .card-header .btn-link {
    width: 95%;
  }
  #faq-page.faq .card-header .btn-link::after {
    right: -4.3% !important;
  }
  #faq-page.faq .card-header .btn-link::before {
    right: -5.9% !important;
  }
  #banner-section.games.tournaments .banner-left {
    left: -8%;
    top: 10%;
    width: 50%;
  }
  #banner-section.games {
    padding-top: 140px;
    padding-bottom: 0;
  }
  .bottom-item .right-area {
    margin-top: 30px;
  }
  #jackpot-section {
    background-size: 330%;
    background-position-x: 43%;
  }
}

@media (max-width: 575px) {
  h1,
  h1 > a {
    font-size: 40px;
    line-height: 46px;
  }
  h2,
  h2 > a {
    font-size: 30px;
    line-height: 36px;
  }
  h3,
  h3 > a {
    font-size: 24px;
    line-height: 28px;
  }
  h4,
  h4 > a {
    font-size: 18px;
    line-height: 22px;
  }
  h5,
  h5 > a {
    font-size: 14px;
    line-height: 18px;
  }
  h6,
  h6 > a,
  a,
  p,
  span,
  li,
  .cmn-btn,
  table thead tr th {
    font-size: 14px;
    line-height: 18px;
  }
  #banner-section {
    padding-top: 130px;
  }
  #jackpot-section .slick-initialized .slick-prev {
    right: 0;
  }
  #jackpot-section .slick-initialized .slick-next {
    right: 70px;
  }
  #faq-section .overlay .left-area,
  #faq-section .overlay .left-area span {
    text-align: center;
  }
  #feature-game-section .section-header {
    text-align: center;
  }
  #available-game-section .contained-area .col-lg-3 {
    text-align: center;
  }
  #footer-section .footer-top .col-lg-6 {
    padding: 0 30px;
  }
  #feature-game-section .feature-game-carousel {
    margin-top: 30px;
  }
  #level-up-section .right-area .single-item img {
    max-width: 60%;
  }
  #level-up-section .section-header {
    text-align: center;
  }
  #banner-section.games.tournaments.faq .banner-right {
    width: 42%;
    top: 70px;
  }
  #banner-section.games.faq {
    padding-bottom: 0;
  }
  #todays-winner-section.home .section-header {
    margin-bottom: 30px;
    text-align: center;
  }
  #todays-winner-section .jus-end {
    justify-content: center;
  }
  #tournaments-games .tab-content .mb-cus .col-lg-3 {
    padding: 0 15%;
    margin-bottom: 15px;
  }
  #tournaments-games .tab-content .nice-select {
    padding: 7px 15px;
  }
  #faq-section .overlay .left-area img {
    max-width: 50%;
  }
  #faq-section .overlay .left-area span::before {
    padding: 80px;
  }
  #faq-section .overlay .left-area span::after {
    padding: 110px;
    left: 15%;
    top: -15%;
  }
  #faq-section .overlay .left-area::before {
    padding: 125px;
    left: 10%;
    top: -23%;
  }
  #faq-section .overlay .left-area::after {
    padding: 140px;
    left: 5%;
    top: -30%;
  }
  #footer-section .section-header p {
    font-size: 16px;
    line-height: 20px;
  }
  #header-section .header-area {
    margin-left: 0;
    margin-right: 0;
  }
  #banner-section.inner-banner .breadcrumb-area ol li,
  #banner-section.inner-banner .breadcrumb-area ol li a {
    font-size: 16px;
  }
  #tournament-section .slick-initialized .slick-prev {
    right: 0;
  }
  #tournaments-prize .single-item {
    margin-bottom: 30px;
  }
  #tournaments-prize .cmn-btn {
    margin-top: 10px;
  }

  .vector-title {
    padding-bottom: 25px;
  }

  #home-here .hero-banner {
    height: 600px;
  }

  #home-here .hero-banner .bottom-area {
    padding-top: 150px;
  }

  .countdown {
    flex-direction: column;
  }
  .countdown .time-unit {
    padding: 15px;
  }

  .countdown .countdown-button {
    width: 100%;
    margin: 0;
  }

  #home-here .hero-banner .bottom-area .bet-details {
    padding: 0;
  }
}

@media (max-width: 480px) {
  #banner-section .banner-content .single-item .left-area img {
    margin: 0 15px;
    max-width: 70%;
  }
  #banner-section .banner-content .single-item {
    padding: 25px 15px 21px 0;
  }
  #available-game-section .right-area {
    text-align: center;
  }
  #level-up-section .right-area .justify-content-between {
    display: grid !important;
    justify-content: center !important;
    margin-bottom: -30px;
  }
  #level-up-section .right-area .single-item img {
    max-width: 90px;
  }
  #level-up-section .right-area .single-item {
    margin-bottom: 30px;
  }
  #level-up-section .right-area .single-item h6 {
    margin-top: 15px;
  }
  #todays-winner-section .winner-chart .single-item {
    text-align: center !important;
    justify-content: center !important;
    display: grid !important;
    padding: 30px 0;
  }
  #todays-winner-section .winner-chart .single-item .left-area .name-area {
    margin: 20px 0;
  }
  #todays-winner-section .winner-chart .single-item .left-area {
    display: grid !important;
    justify-content: center !important;
  }
  #todays-winner-section .winner-chart .single-item .left-area .pos {
    margin: auto;
  }
  #counter-section .single-item {
    margin-bottom: 30px;
  }
  #counter-section .single-item span {
    font-size: 20px;
    line-height: 28px;
    margin: 5px 0 2px;
  }
  #jackpot-section .right-area .couter-area {
    margin: 30px 0 30px;
  }
  #jackpot-section .carousel-jackpot .single-item h6 {
    top: 10px;
    left: 15px;
    padding: 10px 12px;
  }
  #latest-activites-section .table-responsive {
    padding: 10px;
  }
  #latest-activites-section .table {
    width: 230%;
  }
  #latest-activites-section .table th,
  #latest-activites-section .table td {
    padding-left: 10px;
  }
  #faq-page.faq .nav-tabs .nav-item {
    margin: 8px 10px;
  }
  #leaderboard-prize .table {
    width: 130%;
  }
  .card-header {
    padding: 12px 0 12px 0;
  }
  #faq-section .overlay .card-header .btn-link {
    text-align: start;
    padding-right: 40px;
  }
  #faq-section .overlay .card-header .collapsed.btn-link::after {
    right: 18px;
  }
  #faq-section .overlay .card-header .btn-link::before {
    right: 10px;
  }
  #faq-section .overlay .card-header .btn-link::after {
    right: 15px;
  }
  #faq-section .overlay .card-body {
    padding: 12px 15px 12px;
  }
  #tournaments-games .tab-content .all-items {
    justify-content: center;
  }
  #tournaments-games .tab-content .single-item,
  #tournaments-games .tab-content .single-item.list {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 1 - 15px);
    -ms-flex: 0 0 calc(100% / 1 - 15px);
    max-width: calc(100% / 1 - 15px);
    padding: 15px 10px;
  }
  #footer-section .section-header p {
    font-size: 14px;
    line-height: 18px;
  }
  #footer-section .footer-bottom .left-area p {
    margin: 35px 12px 0;
    line-height: 26px;
    text-align: center;
  }
  #footer-section .bottom-area .header-area .col-lg-8 {
    display: grid !important;
  }
  #footer-section .bottom-area .header-area .logo-section {
    text-align: center;
    margin-bottom: 30px;
  }
  #banner-section .banner-bottom.about .item-area .content-item {
    display: grid !important;
  }
  #banner-section .banner-bottom.about .item-area .mb-cus {
    margin-bottom: 0 !important;
  }
  #banner-section .banner-bottom.about .item-area .single-item {
    margin-bottom: 30px;
  }
  #banner-section.games .banner-side {
    right: 2%;
    bottom: 6%;
    width: 50%;
  }
  #leading-brand .bg-right {
    display: none;
  }
  #faq-page.faq .card-header .btn-link::after {
    right: -0.3% !important;
  }
  #faq-page.faq .card-header .btn-link::before {
    right: -2.9% !important;
  }
  #available-game-section.index-2.games-2 .nav-tabs {
    display: flex;
  }
  #available-game-section.index-2 .nav-tabs {
    display: grid;
  }
  #available-game-section.index-2 .nav-tabs .nav-item {
    margin: 11px 18px;
    text-align: center;
  }
  #available-game-section.games .overlay .menu-bar .cmn-btn {
    padding: 8px 12px;
  }
  #jackpot-section .right-area h1 span {
    padding: 15px 6px;
    margin: -5px;
  }
  #banner-section.tourn-details .bottom-area .bet-details {
    padding: 0 3%;
  }
  #tournament-section .section-header h3 {
    width: 55%;
  }
  #tournament-section .slick-initialized .slick-next {
    right: 55px;
  }
}

@media (max-width: 420px) {
  #latest-activites-section .table {
    width: 394%;
  }
  #banner-section .banner-bottom.about .item-area {
    transform: translate(0, -20px);
  }
  #story-behind-gainio {
    margin-top: 330px;
    background-color: var(--body-bg);
  }
  #story-behind-gainio .btn-area a {
    padding: 10px 12px;
    margin: 0 7px;
  }
}

.mid {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bet-details {
  position: relative;
  text-align: center;
  display: flex; 
  justify-content: space-between;
}

.bet-details .left, .bet-details .right {
  min-width: 50px;
}

.bet-details .mid {
  flex-grow: 1;
} 
 
@media (min-width: 601px) {
  .flex-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
 
@media (max-width: 600px) {
  .flex-container {
    flex-direction: column;
    align-items: center;
  }

  .TournamentEnrollment {
    padding-top:20px;
    padding-bottom:20px;
  }
}

.btnLogin {
  border-left:2px solid #ffffff;
  margin-top:20px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB,2JAA2J;AAE3J;EACE,gCAAgC;EAChC,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;EAME,UAAU;EACV,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,iCAAiC;EACjC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;;EAGE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,yDAAmD;EACnD,+BAA+B;EAC/B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;EACb;EACA;IACE,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,kBAAkB;EAElB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,aAAa;IAEb,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EAEZ,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EAEnB,gCAAgC;EAGhC,uCAAuC;AAEzC;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAE7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,OAAO;EACT;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mFAAwE;EACxE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,sBAAsB;EAEtB,yBAAyB;AAC3B;;AAiBA;EACE;IACE,UAAU;IAGV,mCAAmC;EACrC;EACA;IACE,UAAU;IAGV,eAAe;EACjB;AACF;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE;IAKE,qBAAqB;EACvB;AACF;;AAqBA;EACE;IAEE,8BAA8B;EAChC;EACA;IAEE,gCAAgC;EAClC;EACA;IAEE,8BAA8B;EAChC;EACA;IAEE,8BAA8B;EAChC;AACF;;AAqBA;EACE;IAEE,8BAA8B;EAChC;EACA;IAEE,+BAA+B;EACjC;EACA;IAEE,+BAA+B;EACjC;EACA;IAEE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yDAA+C;EAC/C,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yDAA+C;EAC/C,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,YAAY;EAGZ,uBAAuB;AACzB;;AAEA;EAGE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,UAAU;AACV;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,yDAA0C;EAC1C,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yDAA8C;EAC9C,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,yDAAoD;EACpD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,oDAAoD;EACpD,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,UAAU;EAEV,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,UAAU;EAEV,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,WAAW;EAEX,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EAEX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;AACA;;AAEA;EACE,yDAA4D;EAC5D,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gFAAgF;EAChF,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;AACA;;AAEA;AACA;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,cAAc;AACd,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yDAAqD;EACrD,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAEhB,wBAAwB;EACxB,kBAAkB;EAElB,4DAA4D;EAC5D,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,2DAA2D;EAC3D,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EAET,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,SAAS;EAET,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,QAAQ;EAER,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uEAAuE;EACvE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yDAA+C;EAC/C,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,0DAA+C;EAC/C,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oDAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,oDAA0C;EAC1C,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0DAAgD;EAChD,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,0DAAmD;EACnD,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0DAA2D;EAC3D,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,kGAAkG;EAClG,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAA+B;EAA/B,cAA+B;EAA/B,iCAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,+DAA+D;EAC/D,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oDAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,oDAAwC;EACxC,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;EAC5B,mBAAmB;EACnB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yDAAyD;EACzD,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB;;wBAEsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yDAA+C;EAC/C,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yDAAgD;EAChD,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;;;;GAIG;;AAEH,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,WAAW;IACX,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,WAAW;IACX,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;;;;IAQE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,oCAAoC;IACpC,mCAAmC;EACrC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;;IAEE,QAAQ;EACV;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;;IAEE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,MAAM;IACN,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,UAAU;IACV,SAAS;EACX;EACA;IACE,WAAW;IACX,MAAM;IACN,UAAU;IACV,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,WAAW;IACX,WAAW;IACX,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,6BAA6B;EAC/B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IAEE,kCAAkC;EACpC;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;IACV,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,MAAM;IACN,QAAQ;IACR,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;EACZ;EACA;;IAEE,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,SAAS;EACX;EACA;;IAEE,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;IAC/B,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;;;;IAQE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,SAAS;IACT,SAAS;EACX;EACA;IACE,cAAc;IACd,SAAS;IACT,SAAS;EACX;EACA;IACE,cAAc;IACd,QAAQ;IACR,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;IACxB,kCAAkC;IAClC,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,kCAAkC;IAClC,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,kCAAkC;EACpC;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,YAA+B;IAA/B,cAA+B;IAA/B,iCAA+B;IAC/B,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,UAAU;IACV,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;EACA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB","sourcesContent":["/* reset css start */\n/* @import url(\"https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@300;400;500;600;700&family=Roboto:wght@100;300;400;500;700;900&display=swap\"); */\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Roboto:wght@100;300;400;500;700;900&display=swap\");\n:root {\n  --body-font: \"Inter\", sans-serif;\n  --body-alt-font: \"Inter\", sans-serif;\n  --body-color: rgb(255, 255, 255);\n  --body-bg: #000000;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n}\n\nbody {\n  font-family: var(--body-font);\n  background-color: var(--body-bg);\n  font-size: 18px;\n  line-height: 25px;\n  padding: 0;\n  margin: 0;\n  font-weight: 400;\n  overflow-x: hidden;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  padding: 0;\n  margin: 0;\n}\n\nh1,\nh1 > a,\nh2,\nh2 > a,\nh3,\nh3 > a,\nh4,\nh4 > a,\nh5,\nh5 > a,\nh6,\nh6 > a {\n  font-family: var(--body-alt-font);\n  color: var(--body-color);\n  line-height: 1.25;\n  font-weight: 600;\n  text-transform: initial;\n  transition: all 0.3s;\n  -webkit-transition: all 0.3s;\n  -moz-transition: all 0.3s;\n  -ms-transition: all 0.3s;\n  -o-transition: all 0.3s;\n}\n\nh1 > a:hover,\nh2 > a:hover,\nh3 > a:hover,\nh4 > a:hover,\nh5 > a:hover,\nh6 > a:hover {\n  color: var(--body-color);\n}\n\nh1,\nh1 > a {\n  font-size: 76px;\n  line-height: 91.2px;\n}\n\nh2,\nh2 > a {\n  font-size: 57px;\n  line-height: 68.4px;\n}\n\nh3,\nh3 > a {\n  font-size: 43px;\n  line-height: 51.6px;\n}\n\nh4,\nh4 > a {\n  font-size: 32px;\n  line-height: 38.4px;\n}\n\nh5,\nh5 > a {\n  font-size: 24px;\n  line-height: 28px;\n}\n\nh6,\nh6 > a {\n  font-size: 18px;\n  line-height: 21.6px;\n}\n\ntable thead tr th {\n  font-size: 18px;\n  line-height: 21.6px;\n}\n\na {\n  display: inline-block;\n  color: var(--body-color);\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 25px;\n}\n\na,\na:focus,\na:hover {\n  text-decoration: none;\n  outline: none;\n  color: rgb(255, 255, 255);\n}\n\np,\nspan,\nli {\n  margin: 0;\n  font-family: var(--body-font);\n  font-size: 18px;\n  font-weight: 400;\n  color: #dce6ff;\n  line-height: 25px;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\nul,\nol {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\nbutton:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\ninput:focus,\ntextarea:focus {\n  outline: none;\n  box-shadow: none;\n}\n\nbutton {\n  border: none;\n  cursor: pointer;\n}\n\ninput,\ntextarea {\n  padding: 10px 25px;\n  border: 1px solid #4450b8;\n  width: 100%;\n  font-family: var(--body-font);\n}\n\nselect {\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  outline: none;\n}\n\ntextarea {\n  min-height: 150px;\n  resize: none;\n}\n\nspan {\n  display: inline-block;\n}\n\n.table thead th,\n.table td,\n.table th {\n  border: none;\n}\n\n.main-container {\n  margin-top: 100px;\n  margin-bottom: 100px;\n}\n\n.bg_img {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.bg_img {\n  background-position: center;\n  background-size: cover;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mr-60 {\n  margin-right: 60px;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.button-group {\n  display: inline-flex;\n  overflow: hidden;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.b-none {\n  border: none !important;\n}\n\n.section-header {\n  margin-top: -12px;\n  margin-bottom: 56px;\n}\n\n.title {\n  font-family: var(--body-alt-font);\n  color: var(--body-color);\n  font-weight: 700;\n  /* text-transform: uppercase; */\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.title span {\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n  font-weight: inherit;\n  color: #04f0f6;\n}\n\n.vector-title {\n  padding: 16px 80px 16px 80px;\n  margin-bottom: -26px;\n  font-size: 32px;\n  background-image: url(\"../images/vector-title.png\");\n  background-position: top center;\n  background-repeat: no-repeat;\n  color: #000000;\n}\n\niframe {\n  border: 0;\n  width: 100%;\n}\n\n@media (max-width: 991px) {\n  .section-title {\n    font-size: 40px;\n  }\n}\n\n@media (max-width: 575px) {\n  .sub-title,\n  .sub-title-alt {\n    font-size: 12px;\n  }\n}\n\n.section-title span {\n  color: var(--primary-color);\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n  font-weight: inherit;\n}\n\n.shadow-none {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.mb-30-none {\n  margin-bottom: -30px;\n}\n\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.mb-40 {\n  margin-bottom: 40px;\n}\n\n.mb-40-none {\n  margin-bottom: -40px;\n}\n\n.mt-30 {\n  margin-top: 30px;\n}\n\n.pt-120 {\n  padding-top: 120px;\n}\n\n@media (max-width: 991px) {\n  .pt-120 {\n    padding-top: 60px;\n  }\n}\n\n@media (max-width: 575px) {\n  .pt-120 {\n    padding-top: 50px;\n  }\n}\n\n.pb-120 {\n  padding-bottom: 120px;\n}\n\n@media (max-width: 991px) {\n  .pb-120 {\n    padding-bottom: 60px;\n  }\n}\n\n@media (max-width: 575px) {\n  .pb-120 {\n    padding-bottom: 50px;\n  }\n}\n\n.pt-60 {\n  padding-top: 60px;\n}\n\n@media (max-width: 991px) {\n  .pt-60 {\n    padding-top: 30px;\n  }\n}\n\n@media (max-width: 575px) {\n  .pt-60 {\n    padding-top: 25px;\n  }\n}\n\n.pb-60 {\n  padding-bottom: 60px;\n}\n\n@media (max-width: 991px) {\n  .pb-60 {\n    padding-bottom: 30px;\n  }\n}\n\n@media (max-width: 575px) {\n  .pb-60 {\n    padding-bottom: 25px;\n  }\n}\n\nbody::-webkit-scrollbar {\n  width: 4px;\n}\n\nbody::-webkit-scrollbar-track {\n  background: #00003e;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background: #535264;\n}\n\nbody::-webkit-scrollbar-thumb:hover {\n  background: #535264;\n}\n\n@media (max-width: 991px) {\n  .header-section .header-top {\n    display: block;\n  }\n}\n\n@media (max-width: 991px) {\n  .navbar-collapse .main-menu {\n    height: 280px;\n    overflow-y: auto;\n  }\n}\n\n.navbar-collapse .main-menu .menu_has_children.show .sub-menu {\n  display: grid;\n}\n\n@media (max-width: 991px) {\n  .menu_has_children .sub-menu {\n    display: none !important;\n  }\n  .menu_has_children .sub-menu li {\n    width: 100%;\n  }\n  .navbar-collapse .main-menu .menu_has_children.show .sub-menu {\n    display: inline-flex !important;\n    flex-wrap: wrap;\n    margin-left: 20px;\n  }\n}\n\n.navbar-collapse .main-menu li:last-child .sub-menu {\n  left: auto;\n  right: 0;\n}\n\n.navbar-collapse .main-menu .cart span {\n  background-color: rgba(183, 165, 255, 0.2);\n  color: #fff;\n  padding: 0 20px;\n  border-radius: 15px;\n  margin-left: 5px;\n}\n\n.navbar-collapse .main-menu .cart-area {\n  top: 40px;\n}\n\n.navbar-collapse .main-menu .cart-area button {\n  background-color: transparent;\n  color: var(--body-color);\n  margin: 0 15px;\n  font-weight: 500;\n}\n\n.navbar-collapse .main-menu li {\n  position: relative;\n}\n\n.navbar-collapse .main-menu li:hover .sub-menu {\n  opacity: 1;\n  visibility: visible;\n  top: 100%;\n}\n\n.navbar-collapse .main-menu li.menu_has_children {\n  position: relative;\n}\n\n.navbar-collapse .main-menu li.menu_has_children i {\n  font-size: 18px;\n  margin-left: 5px;\n}\n\n@media (max-width: 991px) {\n  .navbar-collapse .main-menu li.menu_has_children::before {\n    top: 12px;\n    right: 15px;\n  }\n}\n\n.navbar-collapse .main-menu li a {\n  padding: 40px 25px;\n  font-weight: 800;\n  font-family: var(--body-font);\n  font-size: 18px;\n  text-transform: capitalize;\n}\n\n@media (max-width: 991px) {\n  .navbar-collapse .main-menu li a {\n    padding: 10px 8px;\n    display: block;\n  }\n  .navbar-expand-lg {\n    float: right;\n    width: 100%;\n  }\n}\n\n.navbar-collapse .main-menu li .sub-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 230px;\n  background-color: #0d0d59;\n  padding: 0;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  z-index: 9;\n}\n\n.navbar-collapse .main-menu li .sub-menu li:last-child a {\n  border: none;\n}\n\n.navbar-collapse .main-menu li .sub-menu li a {\n  padding: 15px 20px;\n  display: block;\n  border-bottom: 1px solid #7400d3;\n}\n\n.navbar-collapse .main-menu li .sub-menu li a:hover {\n  border-radius: 0 !important;\n}\n\n.nav-area {\n  display: contents;\n  justify-content: space-between;\n  z-index: 100;\n}\n\n@media (max-width: 991px) {\n  .navbar-collapse .main-menu li .sub-menu {\n    position: initial;\n    opacity: 1;\n    visibility: visible;\n    display: none;\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.menu-toggle {\n  margin: 15px 0;\n  position: relative;\n  display: block;\n  width: 35px;\n  height: 20px;\n  cursor: pointer;\n  background: transparent;\n  border-top: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  font-size: 0;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n}\n\n.menu-toggle.is-active {\n  border-color: transparent;\n}\n\n.menu-toggle::before,\n.menu-toggle::after {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 2px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  background: #ffffff;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  transition: -webkit-transform 0.25s ease-in-out;\n  -webkit-transition: -webkit-transform 0.25s ease-in-out;\n  transition: transform 0.25s ease-in-out;\n  transition: transform 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;\n}\n\n.menu-toggle.is-active::before {\n  -webkit-transform: translate(-50%, -50%) rotate(45deg);\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.menu-toggle.is-active::after {\n  -webkit-transform: translate(-50%, -50%) rotate(-45deg);\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.navbar-toggler {\n  padding-right: 0;\n  display: none;\n}\n\n.toggle-btn {\n  padding: 8px 12px;\n  color: var(--body-color);\n  font-weight: 500;\n  text-transform: capitalize;\n  border: 1px solid transparent;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  border-radius: 4px;\n}\n\n.header-section .header-bottom {\n  padding: 10px 10px;\n}\n\n@media (max-width: 991px) {\n  .navbar-toggler {\n    display: inline-block;\n  }\n  .navbar-light .navbar-toggler {\n    position: absolute;\n    right: 14%;\n    margin-top: 5px;\n    border: none;\n  }\n  .header-area {\n    position: relative;\n    padding: 15px 0;\n  }\n  #header-section .navbar .navbar-brand img {\n    max-width: initial;\n  }\n  #header-section .navbar .navbar-brand {\n    margin-top: -5px;\n    width: 35%;\n  }\n  .navbar-collapse .main-menu {\n    padding-top: 30px;\n  }\n  #header-section .navbar .navbar-bottom {\n    padding: 20px 0;\n  }\n  #header-section .navbar .navbar-top {\n    justify-content: center !important;\n  }\n  #header-section {\n    background-color: var(--body-bg) !important;\n  }\n  #header-section .overlay .navbar-toggler i {\n    color: var(--body-color);\n  }\n  #header-section .navbar .navbar-nav .menu_has_children::after {\n    transform: translateX(70px);\n    left: 0;\n  }\n}\n\n@media (max-width: 800px) {\n  .navbar-light .navbar-toggler {\n    right: 4%;\n  }\n}\n\n@media (max-width: 440px) {\n  #header-section .navbar .navbar-top .language-select-list img {\n    display: none;\n  }\n  #header-section .navbar .navbar-top a {\n    margin: 0 6px !important;\n    font-size: 12px;\n  }\n  #header-section .navbar .navbar-top .language-select-list {\n    margin: 0 !important;\n  }\n  #header-section .navbar .nice-select .option,\n  #header-section .navbar .nice-select.select-bar .current {\n    font-size: 12px;\n  }\n  #header-section .navbar .navbar-brand img {\n    max-width: initial;\n    width: 115px;\n  }\n  .navbar-light .navbar-toggler {\n    margin-top: 0;\n  }\n  #header-section .navbar .navbar-collapse .navbar-nav {\n    padding-right: 0;\n  }\n}\n\n.scrollToTop {\n  position: fixed;\n  bottom: 0;\n  right: 30px;\n  width: 45px;\n  height: 45px;\n  background-color: #4e01ce;\n  border-radius: 5px;\n  color: #fff;\n  line-height: 45px;\n  font-size: 20px;\n  text-align: center;\n  z-index: 9;\n  cursor: pointer;\n  transition: all 1s;\n  transform: translateY(100%);\n}\n\n.scrollToTop.active {\n  bottom: 30px;\n  transform: translateY(0%);\n  color: #fff;\n}\n\n.scrollToTop:hover {\n  color: #fff;\n}\n\n.preloader {\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  z-index: 99999999;\n  overflow: visible;\n  background: #00003e url(../images/preloader.gif) no-repeat center center;\n  background-size: 400px 400px;\n  display: none;\n}\n\n#header-section.header-fixed {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n  background-color: #00003e;\n  box-shadow: 0px 3px 10px 0px rgb(0 0 0 / 30%);\n}\n\n#header-section.header-fixed .header-top,\n#header-section.header-fixed .header-middle {\n  display: none !important;\n}\n\n#header-section.header-fixed .header-bottom {\n  background-color: var(--body-color);\n  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);\n}\n\n#header-section .header-top {\n  padding: 20px 0;\n}\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    -ms-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    -ms-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    -ms-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    -ms-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@keyframes zoomInOut {\n  50% {\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n}\n\n@-webkit-keyframes ripple2Ani {\n  0% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n  33% {\n    -webkit-transform: translate(-5px, -5px);\n    transform: translate(-5px, -5px);\n  }\n  66% {\n    -webkit-transform: translate(5px, 5px);\n    transform: translate(5px, 5px);\n  }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ripple2Ani {\n  0% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n  33% {\n    -webkit-transform: translate(-5px, -5px);\n    transform: translate(-5px, -5px);\n  }\n  66% {\n    -webkit-transform: translate(5px, 5px);\n    transform: translate(5px, 5px);\n  }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n}\n\n@-webkit-keyframes rippleAni {\n  0% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n  33% {\n    -webkit-transform: translate(5px, -5px);\n    transform: translate(5px, -5px);\n  }\n  66% {\n    -webkit-transform: translate(-5px, 5px);\n    transform: translate(-5px, 5px);\n  }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes rippleAni {\n  0% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n  33% {\n    -webkit-transform: translate(5px, -5px);\n    transform: translate(5px, -5px);\n  }\n  66% {\n    -webkit-transform: translate(-5px, 5px);\n    transform: translate(-5px, 5px);\n  }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes zoominout {\n  0% {\n    transform: scale(1, 1);\n  }\n  50% {\n    transform: scale(1.2, 1.2);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n\n.TournamentEnrollment { \n  width:100%; \n  border-radius: 0px!important;\n  background-color: #00ccff!important;\n  color: white!important;\n  padding: 10px 20px;\n  font-size: 1em; \n  border-top: 2px solid #ffffff;\n  border-right: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  border-left: 0px;\n  box-shadow: 0px!important; \n  padding-top: 40px;\n  padding-bottom: 40px;\n  max-width: 250  px;  \n}\n/* cmn btn */\n.cmn-btn {\n  position: relative;\n  color: rgb(255, 255, 255);\n  font-size: 18px;\n  font-weight: 900;\n  text-transform: uppercase;\n  background: #04f0f6;  \n  transition: all ease 0.3s;\n  padding: 12px 30px;\n}\n\n.cmn-btn:hover {\n  background: #04f0f6;\n  box-shadow: 0px 4px 0px #04f0f6;\n  transition: all ease 0.3s;\n}\n\n.cmn-btn img {\n  margin-bottom: 4px;\n  margin-left: 4px;\n}\n\n.cmn-btn-alt {\n  background: #4e01ce;\n  box-shadow: 0px 4px 0px #4707b3;\n}\n\n.cmn-btn-alt:hover {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #57049a;\n}\n\n.cmn-btn-second {\n  padding: 8px 15px;\n  border-radius: 25px;\n  border: 1px solid #be97ff;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 18px;\n  color: #ffffff;\n  background: transparent;\n  transition: all ease 0.3s;\n}\n\n.cmn-btn-second:hover {\n  border: 1px solid #7400d3;\n  background: #7400d3;\n  transition: all ease 0.3s;\n}\n\n/* header area */\n#header-section {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n  background-color: transparent;\n}\n\n#header-section .site-logo {\n  margin-top: -4px;\n}\n\n#header-section .header-area {\n  border-bottom: 1px solid #04f0f6;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding:10px;\n}\n\n#header-section.header-fixed .header-area {\n  border: none;\n}\n\n#header-section .navbar .navbar-nav .dropdown a,\n#header-section .right-area span,\n#header-section .navbar .navbar-nav li a {\n  color: #fff;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 25px;\n  text-transform: uppercase;\n}\n\n#header-section .navbar .navbar-nav li a.active,\n#header-section .navbar .navbar-nav li a:hover {\n  color: #04f0f6;\n}\n\n#header-section .navbar .navbar-nav .menu_has_children a {\n  padding-right: 40px;\n}\n\n#header-section .navbar .navbar-nav .menu_has_children {\n  display: grid;\n  align-items: center;\n}\n\n#header-section .navbar .navbar-nav .menu_has_children::after {\n  position: absolute;\n  content: \"\";\n  background-image: url(../images/down-arrow.png);\n  background-repeat: no-repeat;\n  height: 7px;\n  width: 15px;\n  right: 15px;\n  transition: all ease 0.3s;\n}\n\n#header-section .navbar .navbar-nav .dropdown {\n  display: flex;\n  align-items: center;\n}\n\n#header-section .right-area .nice-select {\n  padding-left: 5px;\n}\n\n#header-section .right-area .cmn-btn {\n  margin-left: 10px;\n}\n\n#header-section .nice-select:after {\n  position: absolute;\n  content: \"\";\n  background-image: url(../images/down-arrow.png);\n  background-repeat: no-repeat;\n  height: 7px;\n  width: 15px;\n  right: 6px;\n  transition: all ease 0.3s;\n  border: none;\n  -webkit-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n}\n\n#header-section .nice-select.open:after {\n  -webkit-transform: rotate(-180deg);\n  -ms-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n  right: 15px;\n  margin-top: -5px;\n}\n\n#header-section .nice-select.open .list {\n  background-color: #0d0d59;\n}\n\n#header-section .nice-select .option:hover,\n#header-section .nice-select .option.focus,\n#header-section .nice-select .option.selected.focus {\n  background-color: transparent;\n  color: #04f0f6;\n}\n\n/* modal */\n/* .modal-backdrop {\n  height: initial;\n} */\n\n.modal .register .modal-body {\n  padding: 0;\n}\n\n.modal .register .modal-content .comn-btn {\n  width: 100%;\n}\n\n.modal .register .modal-content {\n  padding: 30px 0px 0px;\n  background: #11a5a9;\n  box-shadow: 0px 20px 50px #11a5a9;\n  border-radius: 30px;\n}\n\n.checkbox_wrapper {\n  position: relative;\n  height: 16px;\n  width: 17px;\n  margin-top: 8px;\n}\n\ninput[type=\"checkbox\"] {\n  /* opacity: 0; */\n  height: 16px;\n  width: 17px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n\ninput[type=\"checkbox\"] + label {\n  background-image: url(../images/check.png);\n  background-repeat: no-repeat;\n  height: 18px;\n  width: 18px;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  border: 1px solid #47399b;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"]:checked + label {\n  background-image: none;\n  background-repeat: no-repeat;\n  height: 18px;\n  width: 18px;\n  display: inline-block;\n  border: 1px solid #47399b;\n  border-radius: 5px;\n}\n\n.modal .register .modal-content .close {\n  padding: 6px 10px;\n  margin: 0;\n  background: #820103;\n  border-radius: 50%;\n}\n\n.modal .register .modal-content .modal-header {\n  border: none;\n  border: none;\n  padding: 0 30px 0;\n}\n\n.modal .register .modal-content .modal-body form .form-control:focus {\n  border: 1px solid #04f0f6;\n}\n\n.modal .register .modal-content .modal-body form input {\n  background: #350981;\n  color: var(--body-color);\n  border: 1px solid #47399b;\n}\n\n.modal .register .modal-content .modal-body form label {\n  color: var(--body-color);\n}\n\n.modal .register .modal-content .modal-header button.btn-close {\n  display: none;\n}\n\n.modal .register .modal-content .modal-body h5.welcome {\n  width: 100%;\n}\n\n.modal .register .modal-content .modal-body h5 {\n  /* text-transform: uppercase; */\n  text-align: center;\n  /* width: 35%; */\n  margin: 0 auto;\n  padding: 8px 0 6px;\n  margin-bottom: 15px;\n}\n\n.modal .register .modal-content .modal-body p a {\n  color: #04f0f6;\n  text-transform: uppercase;\n}\n\n.modal .register .modal-content .modal-body p {\n  text-align: center;\n  margin: 0 0 37px;\n}\n\n.modal .register .modal-content .modal-body .form-area {\n  padding: 30px 30px 30px 30px;\n  background: #341211;\n  border-radius: 30px;\n}\n\n.btnClose {\n  width: 25px;\n  margin:15px;\n}\n\n.modal .register .modal-content .modal-body .form-area .res_info {\n  color: #fff;\n  text-align: center;\n}\n\n.modal .register .modal-content .modal-body .form-group .check_span {\n  margin-left: 16px;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--body-color);\n  font-weight: 400;\n}\n\n.modal .register .modal-content .modal-body .form-group .cmn-btn {\n  margin-left: 0;\n  width: 100%;\n  margin-top: 25px;\n}\n\n.modal .register .modal-content .modal-body .form-group .cmn-btn:disabled {\n  background-color: #382945;\n}\n\n.modal .register .modal-content .modal-body a.exchange-link {\n  color: #04f0f6;\n}\n\n.modal .register .modal-content .modal-body .form-group .check_span span {\n  color: #04f0f6;\n  font-size: 13px;\n  font-weight: inherit;\n  line-height: inherit;\n}\n\n.modal .register .modal-content .modal-body .reg-with p {\n  color: var(--body-color);\n  text-transform: uppercase;\n  margin-top: 35px;\n}\n\n.modal .register .modal-content .modal-body .reg-with .social-area a {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 16px;\n}\n\n.modal .register .modal-content .modal-body .reg-with .social-area a img {\n  z-index: 1;\n}\n\n.modal .register .modal-content .modal-body .reg-with .social-area a::before {\n  position: absolute;\n  content: \"\";\n  z-index: 0;\n  width: 30px;\n  height: 30px;\n  background-image: url(../images/social-bg.png);\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n.modal .register .modal-content .modal-body .reg-with .social-area a:hover::before {\n  background-image: url(../images/social-bg-hover.png);\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n/* banner-section */\n#banner-section {\n  position: relative;\n  padding-top: 167px;\n  /* background-color: #141461; */\n  /* background-image: url(../images/banner-bg.png); */\n  background-size: 100%;\n  background-repeat: no-repeat;\n  margin-bottom: 60px;\n}\n\n#banner-section .main-content h1 {\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n#banner-section .main-content h1 span {\n  color: #04f0f6;\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n#banner-section .main-content .cmn-btn {\n  margin-top: 35px;\n  margin-bottom: 20px;\n}\n\n#banner-section .banner-content .col-lg-12 {\n  z-index: 3;\n}\n\n#banner-section .banner-content .ani-img {\n  position: relative;\n  top: -40%;\n}\n\n#banner-section .banner-content .ani-img img {\n  position: absolute;\n}\n\n#banner-section .banner-content .ani-img .cir-1 {\n  top: 0%;\n  left: -15%;\n  -webkit-animation: ripple2Ani 4s linear infinite;\n  animation: ripple2Ani 4s linear infinite;\n}\n\n#banner-section .banner-content .ani-img .cir-2 {\n  top: 200px;\n  left: -35%;\n  -webkit-animation: ripple2Ani 3s linear infinite;\n  animation: ripple2Ani 3s linear infinite;\n}\n\n#banner-section .banner-content .ani-img .cir-3 {\n  top: 0%;\n  right: -15%;\n  -webkit-animation: rippleAni 4s linear infinite;\n  animation: rippleAni 4s linear infinite;\n}\n\n#banner-section .banner-content .ani-img .cir-4 {\n  top: 200px;\n  right: -35%;\n  -webkit-animation: rippleAni 3s linear infinite;\n  animation: rippleAni 3s linear infinite;\n}\n\n#banner-section .banner-content .ani-illu {\n  position: relative;\n  bottom: -35px;\n  z-index: 0;\n}\n\n#banner-section .banner-content .ani-illu img {\n  position: absolute;\n}\n\n#banner-section .banner-content .ani-illu .left-1 {\n  left: 0;\n  bottom: 0;\n}\n\n#banner-section .banner-content .ani-illu .right-2 {\n  right: 0;\n  bottom: 0;\n}\n\n#banner-section .banner-content .bottom-item {\n  border-radius: 10px;\n  background-color: #0d0d59;\n  margin-bottom: -70px;\n  z-index: 3;\n  margin-right: 15px;\n  margin-left: 15px;\n}\n\n#banner-section .banner-content .single-item {\n  padding: 22px 0 26px;\n}\n\n#banner-section .banner-content .single-item .left-area {\n  display: grid;\n}\n\n#banner-section .banner-content .single-item .left-area img {\n  margin: 0 30px;\n  max-width: inherit;\n}\n\n#banner-section .banner-content .single-item .right-area h4 {\n  margin-bottom: 9px;\n}\n\n/* Home here */\n#home-here {\n}\n\n#home-here .hero-banner {\n  background-image: url(\"../images/tournament/x50-hero-3.png\");\n  background-position: top center;\n  background-repeat: no-repeat;\n  height: 800px;\n  background-size: contain;\n}\n\n@media (max-width: 991px) {\n  #home-here .hero-banner {\n    background-position: center 50px;\n  }\n}\n\n\n#home-here .hero-banner .bottom-area {\n  padding-top: 380px;\n}\n\n#home-here .hero-banner .bottom-area h3 {\n  text-transform: uppercase;\n  margin: 20px 0 30px;\n}\n\n#home-here .hero-banner .bottom-area .prize-area {\n  padding: 15px 0 10px;\n  background: #370cbc;\n  margin-bottom: 30px;\n}\n\n#home-here .hero-banner .bottom-area .bet-details {\n  margin-bottom: 40px;\n  padding: 0 15%;\n  margin-top: 70px;\n}\n\n#home-here .hero-banner .bottom-area .bet-details h6,\n#home-here .hero-banner .bottom-area .prize-area h6 {\n  /* font-size: 13px; */\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n#home-here .hero-banner .bottom-area .prize-area .prize {\n  margin-top: 10px;\n}\n\n#home-here .hero-banner .bottom-area .prize-area h5 {\n  color: #04f0f6;\n  font-weight: 700;\n  margin-left: 5px;\n}\n\n#home-here .hero-banner .bottom-area .bet-details h5 {\n  color: #04f0f6;\n  text-transform: uppercase;\n}\n\n#home-here .hero-banner .bottom-area .bet-details h5 span {\n  color: var(--body-color);\n  text-transform: uppercase;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 700;\n}\n\n#home-here .hero-banner .bottom-area .draw-counter {\n  border: 2px solid;\n  border-image-source: linear-gradient(95.57deg, #ffffff -31.36%, #ffffff 159.29%);\n  box-shadow: 0px 0px 44px 0px #7eebe84d;\n  background: #00102b;\n  padding: 10px 80px;\n  /* background: #370cbc; */\n  border-radius: 20px;\n  display: inline-block;\n  margin-bottom: -30px;\n}\n\n#home-here .hero-banner .bottom-area .draw-counter .time-parameter span {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: #04f0f6;\n}\n\n#home-here .hero-banner .bottom-area .draw-counter-new {\n}\n\n#home-here .hero-banner .bottom-area .draw-counter-new div {\n}\n\n#home-here .hero-banner .bottom-area .draw-counter-new .time-parameter span {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: #04f0f6;\n}\n\n/* Home here */\n/* Feature Game */\n#feature-game-section .single-item {\n  padding: 0 15px;\n}\n\n#feature-game-section .container-fluid {\n  margin-bottom: -12px;\n}\n\n#feature-game-section .container .right-area {\n  margin-bottom: 15px;\n}\n\n/* Available Game */\n#available-game-section {\n  /* background-color: #0d0d48; */\n}\n\n#available-game-section .contained-area .col-lg-3 {\n  margin-bottom: 30px;\n}\n\n#available-game-section .right-area .cmn-btn {\n  margin-left: 5px;\n}\n\n/* Level Up */\n#level-up-section {\n  position: relative;\n}\n\n#level-up-section .right-area {\n  display: grid;\n}\n\n#level-up-section .right-area .single-item {\n  text-align: center;\n}\n\n#level-up-section .right-area .single-item h6 {\n  margin-top: 30px;\n  text-transform: uppercase;\n}\n\n/* Todays winner  */\n#todays-winner-section {\n  background-image: url(../images/todays-winner-bg.png);\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n#todays-winner-section.home .section-header {\n  margin-bottom: 0;\n}\n\n#todays-winner-section .title-area {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n#todays-winner-section .title-area h5 {\n  text-transform: uppercase;\n  position: absolute;\n  margin-top: 10px;\n}\n\n#todays-winner-section .winner-chart {\n  background: rgba(104, 62, 254, 0.15);\n  border: 1px solid #9180ff;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 10px rgba(39, 39, 138, 0.7);\n  border-radius: 5px;\n  padding: 8px 0;\n  position: relative;\n  overflow: hidden;\n}\n\n#todays-winner-section .winner-chart .ribbon {\n  position: absolute;\n  padding: 10px 50px;\n  top: 20px;\n  left: -55px;\n  z-index: 1;\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 14px;\n  background: #1b5e42;\n  color: #fff;\n  transform: rotate(315deg);\n  text-align: center;\n}\n\n#todays-winner-section .winner-chart .single-item {\n  background-color: #292994;\n  padding: 10px 30px;\n  margin: 10px 15px;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n}\n\n#todays-winner-section .winner-chart .single-item .left-area img {\n  height: fit-content;\n}\n\n#todays-winner-section .winner-chart .single-item .name-area img {\n  background-color: #03d6f9;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin: 0 10px 0 15px;\n}\n\n#todays-winner-section .winner-chart .single-item .name-area h6 {\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n#todays-winner-section .winner-chart .single-item .win-price {\n  background: #160d96;\n  box-shadow: 0px 4px 8px rgb(12 23 80 / 80%);\n  border-radius: 15px;\n  padding: 5px 10px;\n}\n\n#todays-winner-section .winner-chart .single-item .win-price span {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: #00ff6d;\n}\n\n#todays-winner-section .winner-chart .single-item .win-price .cur {\n  color: #fff;\n  margin-right: 5px;\n}\n\n.fwinner-chart {\n  width: 200px;\n  height: 40px;\n  line-height: 40px;\n  position: absolute;\n  top: 30px;\n  right: -50px;\n  font-size: 20px;\n  color: rgb(255, 255, 255);\n  z-index: 2;\n  overflow: hidden;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  border: 1px dashed;\n  background: -webkit-linear-gradient(45deg, #903eff 0%, #3e19ff 100%);\n  background: linear-gradient(45deg, #903eff 0%, #3e19ff 100%);\n  box-shadow: 0 0 0 3px #903eff, 0px 21px 5px -18px #3f19ff60;\n  text-align: center;\n}\n\n/* Counter Start */\n#counter-section {\n  /* background-color: #00003e; */\n  margin-bottom: -8px;\n}\n\n#counter-section .single-item span {\n  display: block;\n  font-weight: bold;\n  font-size: 32px;\n  line-height: 38px;\n  color: var(--body-color);\n  margin: 12px 0 5px;\n}\n\n#counter-section .single-item .counter {\n  display: inline-block;\n}\n\n#counter-section .single-item h6 {\n  font-weight: bold;\n  color: #03d6f9;\n}\n\n/* Latest Activites */\n#latest-activites-section {\n  position: relative;\n}\n\n#latest-activites-section.games {\n  z-index: 1;\n}\n\n#latest-activites-section.games .ani-div .obj-1 {\n  top: 0;\n  left: 13%;\n  animation: none;\n}\n\n#latest-activites-section::before {\n  content: \"\";\n  /* background-image: url(../images/latest-activites.png); */\n  /* background-color: #141461; */\n  opacity: 0.3;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n#latest-activites-section .ani-div {\n  opacity: 0.3;\n  position: relative;\n  z-index: -1;\n}\n\n#latest-activites-section .ani-div img {\n  position: absolute;\n}\n\n#latest-activites-section .ani-div .obj-1 {\n  top: -30px;\n  left: 13%;\n  -webkit-animation: zoominout 4s infinite;\n  animation: zoominout 4s infinite;\n}\n\n#latest-activites-section .ani-div .obj-2 {\n  top: 125px;\n  right: 4%;\n  -webkit-animation: zoominout 5s infinite;\n  animation: zoominout 5s infinite;\n}\n\n#latest-activites-section .ani-div .obj-3 {\n  top: 320px;\n  left: 2%;\n  -webkit-animation: zoominout 5s infinite;\n  animation: zoominout 5s infinite;\n}\n\n#latest-activites-section .nav-tabs {\n  background: #171789;\n  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.1);\n  border-radius: 28px;\n  text-transform: uppercase;\n  border: none;\n}\n\n#latest-activites-section .nav-tabs .nav-link {\n  border: none;\n  font-weight: 900;\n  padding: 15px 30px;\n  color: var(--body-color);\n}\n\n#latest-activites-section .nav-tabs .nav-link.active {\n  background: #4e01ce;\n  border-radius: 28px;\n}\n\n#latest-activites-section .tab-content {\n  margin-bottom: -180px;\n}\n\n#latest-activites-section .table-responsive {\n  background: linear-gradient(180deg, #1d0d80 0%, rgba(0, 0, 62, 0) 100%);\n  padding: 30px 30px 0 30px;\n}\n\n#latest-activites-section .table {\n  background-color: #141461;\n  margin-bottom: 0;\n}\n\n#latest-activites-section .table th a {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n#latest-activites-section .table th img {\n  width: 50px;\n}\n\n#latest-activites-section .table th,\n#latest-activites-section .table td {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n  color: #e7eaff;\n  width: 0%;\n  padding: 15px 10px;\n  padding-left: 30px;\n  vertical-align: middle;\n}\n\n#latest-activites-section .table thead tr th.text-start {\n  text-align: start;\n}\n\n#latest-activites-section .table thead tr th {\n  text-align: center;\n  text-transform: uppercase;\n}\n\n#latest-activites-section .table thead tr {\n  background: #252595;\n  color: var(--body-color);\n}\n\n#latest-activites-section tbody tr img {\n  /* margin-right: 5px; */\n}\n\n#latest-activites-section tbody tr {\n  background: #141461;\n  border-bottom: 1px solid #182280;\n  border-top: 1px solid #182280;\n  transition: all ease 0.3s;\n}\n\n#latest-activites-section tbody tr th {\n  /* text-align: start !important; */\n}\n\n#latest-activites-section tbody tr td,\n#latest-activites-section tbody tr th {\n  text-align: center;\n}\n\n#latest-activites-section .table tbody tr:hover {\n  background: #13136c;\n  border-bottom: 1px solid #3f4aa9;\n  border-top: 1px solid #3f4aa9;\n  transition: all ease 0.3s;\n}\n\n/* FAQ Activites */\n#faq-section .overlay {\n  /* margin-top: 180px; */\n}\n\n#faq-section .overlay .section-header p {\n  margin: auto 10%;\n}\n\n#faq-section .overlay .left-area {\n  position: relative;\n}\n\n#faq-section .overlay .left-area,\n#faq-section .overlay .left-area span {\n  position: relative;\n}\n\n#faq-section .overlay .left-area span::before {\n  content: \"\";\n  position: absolute;\n  background: #1c1b74;\n  z-index: -5;\n  border-radius: 50%;\n  padding: 160px;\n}\n\n#faq-section .overlay .left-area span::after {\n  content: \"\";\n  position: absolute;\n  background: #1c1b74;\n  opacity: 0.5;\n  z-index: -5;\n  border-radius: 50%;\n  padding: 210px;\n  left: -15%;\n  top: -15%;\n  animation: zoominout 5s linear infinite;\n}\n\n#faq-section .overlay .left-area::before {\n  content: \"\";\n  position: absolute;\n  background: #1c1b74;\n  opacity: 0.3;\n  z-index: -4;\n  border-radius: 50%;\n  padding: 240px;\n  left: -24%;\n  top: -23%;\n  animation: zoominout 5s linear infinite;\n}\n\n#faq-section .overlay .left-area::after {\n  content: \"\";\n  position: absolute;\n  background: #1c1b74;\n  opacity: 0.2;\n  z-index: -3;\n  border-radius: 50%;\n  padding: 265px;\n  left: -32%;\n  top: -31%;\n  animation: zoominout 5s linear infinite;\n}\n\n#faq-section .overlay .card {\n  border: none;\n  margin-bottom: 20px;\n}\n\n#faq-section .overlay .card-header {\n  background: #00102b;\n  border: 2px solid #04f0f633;\n  box-shadow: 0px 0px 15px 0px #7eebe833;\n}\n\n#faq-section .overlay .card-body {\n  background-color: #000000;\n  padding: 15px 30px 20px;\n}\n\n#faq-section .overlay .card-body p {\n  font-size: 14px;\n  line-height: 20px;\n  color: #dce6ff;\n}\n\n#faq-section .overlay .card-header .btn-link {\n  position: relative;\n  color: #ffffff;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  text-transform: uppercase;\n}\n\n#faq-section .overlay .card-header .btn-link::before {\n  position: absolute;\n  content: \"\";\n  /* background-color: #016778; */\n  right: 0;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n#faq-section .overlay .card-header .collapsed.btn-link::after {\n  position: absolute;\n  content: \"\";\n  background-image: url(../images/plus-arrow.png);\n  background-repeat: no-repeat;\n  height: 15px;\n  width: 15px;\n  right: 8px;\n  transform: rotate(90deg);\n  transition: all ease 0.3s;\n}\n\n#faq-section .overlay .card-header .btn-link::after {\n  background-image: url(../images/minus-arrow.png);\n  position: absolute;\n  content: \"\";\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n  transform: rotate(0deg);\n  transition: all ease 0.3s;\n  right: 5px;\n}\n\n/* Footer Section */\n#available-game-section.winners .tab-content .single-item {\n  border: 5px solid #4e01ce;\n  border-radius: 50%;\n}\n\n#available-game-section.winners .tab-content .single-item img {\n  border-radius: 50%;\n  display: block;\n}\n\n#available-game-section.winners .tab-content .single-item span {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n  padding: 10px 25px;\n  background: #4e01ce;\n  border-radius: 14px;\n  position: absolute;\n}\n\n/* Footer Section */\n#footer-section {\n  background: #00102b;\n  border-top: 2px solid #04f0f633;\n  box-shadow: 0px 0px 15px 0px #7eebe833;\n  margin-top: 60px;\n}\n\n#footer-section .section-header {\n  margin-top: -6px;\n}\n\n#footer-section .section-header p {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n#footer-section .footer-top {\n  background-color: #310e9e;\n  margin-top: -260px;\n  border-radius: 10px;\n}\n\n#footer-section .subscribe {\n  background: #ffffff;\n  border: 1px solid #4450b8;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  border-radius: 28px;\n  padding: 5px;\n  display: flex;\n}\n\n#footer-section .subscribe input {\n  border: none;\n  border-radius: 28px;\n}\n\n#footer-section .subscribe .btn {\n  padding: 10px 20px;\n  background: #4e01ce;\n  border-radius: 28px;\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: var(--body-color);\n  margin-right: 5px;\n}\n\n#footer-section .side-contant {\n  position: relative;\n}\n\n#footer-section .side-contant img {\n  position: absolute;\n}\n\n#footer-section .side-contant .left .bg {\n  top: -40px;\n}\n\n#footer-section .side-contant .left .top {\n  left: 10%;\n}\n\n#footer-section .side-contant .right img {\n  right: 0;\n  top: -12px;\n}\n\n#footer-section .navbar-collapse .main-menu li a {\n  padding: 0px 25px;\n  font-weight: 700;\n}\n\n#footer-section .bottom-area {\n  padding-bottom: 30px;\n}\n\n#footer-section .bottom-area ul li a {\n  text-transform: uppercase;\n  padding: 0 15px;\n}\n\n#footer-section .bottom-area ul li a:hover {\n  color: #04f0f6;\n}\n\n#footer-section .footer-bottom .main-content {\n  padding: 30px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n#footer-section .footer-bottom .left-area p {\n  font-size: 16px;\n  line-height: 22px;\n  text-transform: uppercase;\n}\n\n#footer-section .footer-bottom .left-area a {\n  font-size: inherit;\n  line-height: inherit;\n  text-transform: uppercase;\n  color: #04f0f6;\n}\n\n#footer-section .social-area a {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 10px 0 20px;\n}\n\n#footer-section .social-area a img {\n  z-index: 1;\n}\n\n#footer-section .social-area a::before {\n  position: absolute;\n  content: \"\";\n  z-index: 0;\n  width: 30px;\n  height: 30px;\n  /* background-image: url(../images/social-bg.png); */\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n#footer-section .social-area a:hover::before {\n  /* background-image: url(../images/social-bg-hover.png); */\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n#footer-section .footer-bottom .right-area .nice-select {\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  height: 40px;\n}\n\n#footer-section .footer-bottom .right-area .nice-select .list {\n  top: unset;\n  bottom: 100%;\n}\n\n#footer-section .footer-bottom .right-area .nice-select span,\n#footer-section .footer-bottom .right-area .nice-select ul li {\n  text-transform: uppercase;\n}\n\n#footer-section .footer-bottom .right-area .nice-select span {\n  padding: 0 15px 0 0;\n}\n\n#footer-section .main-menu {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n#footer-section .footer-bottom .right-area .nice-select.open .list {\n  background-color: #0d0d59;\n}\n\n#footer-section .footer-bottom .right-area .nice-select .option:hover,\n#footer-section .footer-bottom .right-area .nice-select .option.focus,\n#footer-section .footer-bottom .right-area .nice-select .option.selected.focus {\n  background-color: transparent;\n  color: #04f0f6;\n}\n\n/* Home Page Second  */\n#banner-section.index-2 {\n  background-image: unset;\n}\n\n#banner-section.index-2 .banner-content {\n  position: relative;\n}\n\n#banner-section.index-2 .banner-content .banner-side {\n  position: absolute;\n  right: 5%;\n}\n\n#banner-section.index-2 .main-content .cmn-btn {\n  margin-bottom: 0;\n}\n\n#banner-section.index-2 .banner-content .bottom-item {\n  margin-bottom: -285px;\n  margin-top: -10px;\n}\n\n.bottom-item .bottom-content {\n  background: #0d0d59;\n  border-radius: 10px 0px 0px 10px;\n  padding: 80px 0;\n}\n\n.bottom-item .banner-carousel {\n  margin: 0 0 15px;\n}\n\n.bottom-item .single-item {\n  position: relative;\n}\n\n.bottom-item .single-item img {\n  border-radius: 50%;\n  display: block;\n}\n\n.bottom-item .single-item span {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 2px 8px;\n  background: #4e01ce;\n  border-radius: 14px;\n  position: absolute;\n  bottom: 15px;\n  left: 10px;\n}\n\n.bottom-item .right-area h4 {\n  text-transform: uppercase;\n}\n\n.bottom-item .right-area .couter-area {\n  margin: 20px 0 40px;\n}\n\n.bottom-item .right-area h4 span {\n  text-transform: uppercase;\n  color: #04f0f6;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  background: #191961;\n  border-radius: 5px;\n  padding: 20px 15px;\n  margin: -2px;\n}\n\n#available-game-section.index-2 {\n  background-color: transparent;\n}\n\n#available-game-section.games-2.home-2 .overlay {\n  margin-top: 245px;\n}\n\n#available-game-section.games-2.home-2 .overlay .menu-area {\n  background: transparent;\n}\n\n#available-game-section.index-2 .nav-tabs {\n  border: none;\n}\n\n#available-game-section.home-2.index-2 .cmn-btn-second {\n  margin-top: 60px;\n}\n\n#available-game-section.home-2.index-2 .tab-content {\n  margin: 0;\n}\n\n#available-game-section.index-2 .tab-content {\n  margin: 60px 0;\n}\n\n#available-game-section.index-2 .nav-tabs .nav-item {\n  margin-right: 10px;\n}\n\n#available-game-section.index-2 .input-area {\n  padding: 4px 25px;\n  background: #181868;\n  border: 1px solid #4450b8;\n  box-shadow: 0px 8px 24px rgb(0 0 0 / 10%);\n  border-radius: 28px;\n}\n\n#available-game-section.index-2 .input-area input {\n  background: #181868;\n  color: var(--body-color);\n  border: none;\n  padding: 10px 20px;\n}\n\n/* Jackpot Section */\n#jackpot-section {\n  background-image: url(../images/jackpot-bg.png);\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n#jackpot-section .right-area {\n  margin-top: -12px;\n}\n\n#jackpot-section .right-area h4 {\n  text-transform: uppercase;\n}\n\n#jackpot-section .right-area .couter-area {\n  margin: 39px 0 54px;\n}\n\n#jackpot-section .right-area h1 span {\n  text-transform: uppercase;\n  color: #04f0f6;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n  padding: 20px 15px;\n  margin: -5px;\n}\n\n#jackpot-section .right-area .cmn-btn-second {\n  background-color: #7400d3;\n  border: 1px solid #7400d3;\n}\n\n#jackpot-section .section-header {\n  margin-bottom: 30px;\n}\n\n#jackpot-section .section-header h3 {\n  text-transform: uppercase;\n  margin-left: 20px;\n}\n\n#jackpot-section .jackpot-area {\n  margin-bottom: -260px;\n  z-index: 1;\n}\n\n#jackpot-section .carousel-jackpot .single-item {\n  position: relative;\n}\n\n#jackpot-section .carousel-jackpot .single-item h6 {\n  position: absolute;\n  top: 20px;\n  left: 35px;\n  padding: 10px 30px;\n  background: #4e01ce;\n  border-radius: 10px;\n}\n\n#level-up-section.index-2 {\n  margin-top: -20px;\n  background-color: #00003e;\n}\n\n#jackpot-section .slick-initialized .slick-arrow {\n  position: absolute;\n  background-color: transparent;\n  border-radius: 4px;\n  padding: 2px 5px;\n  line-height: 0;\n  outline: none;\n  transition: all 0.5s;\n}\n\n#jackpot-section .slick-initialized .slick-next {\n  right: calc(8% - -10px);\n  top: -20%;\n  z-index: 1;\n}\n\n#jackpot-section .slick-initialized .slick-prev {\n  right: calc(8% - 60px);\n  top: -20%;\n  z-index: 2;\n}\n\n#jackpot-section .slick-initialized .slick-next,\n#jackpot-section .slick-initialized .slick-prev {\n  background: #4e01ce;\n  box-shadow: 0px 4px 0px #4707b3;\n  border-radius: 28px;\n  padding: 15px 30px;\n  display: inline-block;\n}\n\n#jackpot-section .slick-initialized .slick-next:hover,\n#jackpot-section .slick-initialized .slick-prev:hover {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #57049a;\n}\n\n#jackpot-section .slick-initialized .slick-prev::before,\n#jackpot-section .slick-initialized .slick-next::before {\n  content: \"\";\n  height: 100px;\n  width: 100px;\n  position: absolute;\n  top: 10px;\n  left: 25px;\n}\n\n#jackpot-section .slick-initialized .slick-prev::before {\n  background: url(../images/double-right.png);\n  background-repeat: no-repeat;\n}\n\n#jackpot-section .slick-initialized .slick-next::before {\n  background: url(../images/double-left.png);\n  background-repeat: no-repeat;\n}\n\n/* Features Section */\n#features-section {\n  margin-bottom: -60px;\n  margin-top: 60px;\n}\n\n#features-section .single-item .icon-area {\n  width: 110px;\n  height: 110px;\n  background: #141461;\n  border-radius: 55px;\n  margin: 0 auto;\n}\n\n#features-section .single-item {\n  margin-bottom: 60px;\n}\n\n#features-section .single-item h4 {\n  text-transform: uppercase;\n  margin: 40px 0 20px;\n}\n\n/* Counter Section */\n#counter-section.index-2 .main-content {\n  background: #1c1b74;\n  padding: 40px 0;\n}\n\n#counter-section.index-2 .single-item h6 {\n  margin-bottom: -5px;\n}\n\n/* Faq Section */\n#faq-section.index-2 .overlay {\n  margin: 0;\n}\n\n/* Inner Banner Section */\n#banner-section.inner-banner h1 {\n  text-transform: uppercase;\n}\n\n#banner-section.inner-banner .breadcrumb-area .breadcrumb {\n  background: transparent;\n}\n\n#banner-section.inner-banner .breadcrumb-area ol {\n  padding-left: 3px;\n  margin-bottom: 45px;\n}\n\n#banner-section.inner-banner .breadcrumb-area ol li,\n#banner-section.inner-banner .breadcrumb-area ol li a {\n  font-size: 24px;\n  line-height: 34px;\n  font-weight: 400;\n  color: var(--body-color);\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  padding-right: 20px;\n  margin-top: 10px;\n  content: \"\";\n  background-image: url(../images/arrow-right.png);\n  background-repeat: no-repeat;\n}\n\n/* Inner Section Games */\n#banner-section.games {\n  padding-top: 202px;\n  padding-bottom: 78px;\n  background-image: url(../images/games-inner-bg.png);\n  background-size: 100% 100%;\n  margin-bottom: 0;\n}\n\n#banner-section.games .banner-side {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n#banner-section.hero {\n  background-image: url(\"../images/tournament/x50-hero.webp\");\n  background-size: contain;\n  background-position: top center;\n  background-repeat: no-repeat;\n  /* background-color: #12152E; */\n  padding-top: 280px;\n}\n\n@media (max-width: 991px) {\n  #banner-section.hero {\n    padding-top: 130px;\n    margin-top: 100px;\n  }\n}\n\n/* Available Game */\n#available-game-section.index-2.games {\n  background: #0d0d48;\n}\n\n#available-game-section.index-2.games .overlay {\n  margin-top: 0;\n}\n\n#available-game-section.index-2.games .tab-content {\n  margin: 60px 0 0;\n}\n\n#available-game-section.games .overlay .menu-bar {\n  background: #0e0e67;\n  box-shadow: 0px 8px 12px #09093f;\n  border-radius: 58px;\n  padding: 15px;\n}\n\n#available-game-section.games .overlay .menu-bar .cmn-btn img {\n  background: #6000ff;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n#available-game-section.games .overlay .menu-bar .cmn-btn-alt:hover img {\n  background: #8a0df0;\n}\n\n#available-game-section.games .overlay .menu-bar .active.cmn-btn img {\n  background: #8a0df0;\n}\n\n#available-game-section.games .overlay .menu-bar .active.cmn-btn {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #7400d3;\n}\n\n/* Todays winner */\n#todays-winner-section.games {\n  background-image: unset;\n  background-color: var(--body-bg);\n}\n\n#todays-winner-section.games .left-side {\n  background: radial-gradient(78.16% 122.14% at 50% 54.76%, #fb0078 0%, #3e0b77 63.7%, #2f0c78 100%);\n  border-radius: 20px;\n  padding: 28px 0 59px;\n}\n\n#todays-winner-section.games .left-side .head {\n  text-transform: uppercase;\n  margin-bottom: 15px;\n}\n\n#todays-winner-section.games .left-side .profile {\n  position: relative;\n  display: inline-block;\n  margin-top: 13px;\n}\n\n#todays-winner-section.games .left-side .profile img {\n  border-radius: 50%;\n  margin: 0 auto;\n}\n\n#todays-winner-section.games .left-side .profile h5 {\n  background: #4e01ce;\n  border-radius: 20px;\n  position: absolute;\n  bottom: -20px;\n  transform: translate(-38px, 0px);\n  width: 170px;\n  padding: 6px 0;\n}\n\n#todays-winner-section.games .right-side {\n  background: #480b96;\n  border-radius: 30px;\n  padding: 30px 39px 12px;\n}\n\n#todays-winner-section.games .winner-chart {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n#todays-winner-section.games .winner-chart .single-item {\n  padding: 25px 8px;\n  background: #7818dd;\n  border-radius: 10px;\n}\n\n#todays-winner-section.games .winner-chart .single-item .win-price {\n  background: #480b96;\n}\n\n/* Lavel Up */\n#level-up-section.games {\n  margin-top: 60px;\n}\n\n/* Available Game */\n#available-game-section.games-2 {\n  background: var(--body-bg);\n}\n\n#available-game-section.games-2 .overlay {\n  margin-top: 0;\n}\n\n#available-game-section.games-2 .overlay .menu-area {\n  background: #0d0d48;\n}\n\n#available-game-section.games-2 .overlay .menu-bar {\n  padding: 40px 0;\n}\n\n/* Feature Section */\n#feature-section {\n  margin-top: 60px;\n}\n\n#feature-section .overlay .single-item {\n  padding: 20px;\n  background: #0d0d46;\n  border-radius: 10px;\n}\n\n#feature-section .overlay .single-item .img {\n  width: 80px;\n  height: 80px;\n}\n\n#feature-section .overlay .single-item .img-area {\n  background: #141461;\n  border-radius: 50px;\n  margin-right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n}\n\n#feature-section .overlay .single-item .text-area h5 {\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n\n/* Affiliate Program  */\n#affiliate-program.game-2 {\n  position: relative;\n  background: #0d0d48;\n}\n\n#affiliate-program.game-2 .affiliate-illu {\n  position: absolute;\n  right: -10%;\n  bottom: 0;\n  max-width: 75%;\n}\n\n#affiliate-program.game-2 .section-header p {\n  margin: 10px 0 30px;\n}\n\n#affiliate-program.game-2 .section-header h5 {\n  font-family: var(--body-alt-font);\n}\n\n#affiliate-program.game-2 .section-header h5 span {\n  color: #04f0f6;\n  font-size: inherit;\n  font-weight: inherit;\n  font-family: inherit;\n}\n\n/* Testimonial */\n#testimonial .single-item {\n  background: #0d0d48;\n  border-radius: 20px;\n  padding: 30px;\n}\n\n#testimonial .single-item .star i {\n  color: #ffc107;\n  margin: 0 -2px;\n}\n\n#testimonial .single-item h5 {\n  text-transform: uppercase;\n  margin: 25px 0 15px;\n}\n\n#testimonial .single-item .profile img {\n  background: #03d6f9;\n  border-radius: 50%;\n  margin: 35px auto 20px;\n}\n\n#testimonial .single-item .profile h6 {\n  text-transform: uppercase;\n}\n\n/* Tournaments Pages */\n#banner-section.games.tournaments {\n  background-image: unset;\n}\n\n#banner-section.games.tournaments .banner-left {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n#banner-section.games.tournaments .banner-right {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n#banner-section.games.tournaments .banner-right-illu {\n  position: absolute;\n  right: 0;\n  top: -17%;\n}\n\n/* Tournaments Games */\n#tournaments-games .menu-bar {\n  background: #0e0e67;\n  box-shadow: 0px 8px 12px #09093f;\n  border-radius: 58px;\n  padding: 15px;\n}\n\n#tournaments-games .nav-tabs {\n  border: none;\n}\n\n#tournaments-games .nav-tabs .nav-item {\n  margin-right: 10px;\n}\n\n#tournaments-games .nav-tabs .nav-item .cmn-btn.active {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #57049a;\n}\n\n#tournaments-games .input-area {\n  padding: 4px 25px;\n  background: #181868;\n  border: 1px solid #4450b8;\n  box-shadow: 0px 8px 24px rgb(0 0 0 / 10%);\n  border-radius: 28px;\n}\n\n#tournaments-games .input-area input {\n  background: #181868;\n  color: var(--body-color);\n  border: none;\n  padding: 10px 20px;\n}\n\n#tournaments-games .tab-content .nice-select {\n  background: #141448;\n  border: 1px solid #4450b8;\n  width: 100%;\n  border-radius: 28px;\n  padding: 7px 15px;\n  height: 100%;\n}\n\n#tournaments-games .tab-content .nice-select:after {\n  right: 15px;\n}\n\n#tournaments-games .tab-content .nice-select .list {\n  background: #141448;\n  border: 1px solid #4450b8;\n  width: 100%;\n}\n\n#tournaments-games .nice-select .option:hover,\n#tournaments-games .nice-select .option.focus,\n#tournaments-games .nice-select .option.selected.focus {\n  background-color: transparent;\n  color: #03d6f9;\n}\n\n#tournaments-games .tab-pane .mb-cus {\n  margin: 43px 0;\n}\n\n#tournaments-games .tab-pane i {\n  background: #4e01ce;\n  box-shadow: 0px 4px 0px #4707b3;\n  border-radius: 10px;\n  padding: 19px;\n  color: var(--body-color);\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n#tournaments-games .tab-pane i.active {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #57049a;\n}\n\n#tournaments-games .tab-content .all-items {\n  width: 100% !important;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n#tournaments-games .tab-content .single-item {\n  flex: 0 0 calc(100% / 2 - 15px);\n  -ms-flex: 0 0 calc(100% / 2 - 15px);\n  max-width: calc(100% / 2 - 15px);\n  padding: 30px 20px;\n  border: 1px solid #262975;\n  border-radius: 20px;\n  margin-bottom: 30px;\n  transition: all ease 0.5s;\n}\n\n#tournaments-games .tab-content .single-item .cmn-btn-second {\n  border: 1px solid #4450b8;\n}\n\n#tournaments-games .tab-content .single-item .cmn-btn-second:hover {\n  background: #4450b8;\n}\n\n#tournaments-games .tab-content .single-item.list {\n  justify-content: space-between;\n  display: flex;\n  position: relative;\n  transition: all ease 0.5s;\n}\n\n#tournaments-games .tab-content .single-item.list:after {\n  position: absolute;\n  content: \"\";\n  width: 1px;\n  height: 80%;\n  border: 1px solid #293574;\n  right: calc(37% - 0px);\n  top: 10%;\n}\n\n#tournaments-games .tab-content .single-item .content-area {\n  display: flex;\n}\n\n#tournaments-games .tab-content .single-item.list .grid-style {\n  text-align: start;\n  margin: 0 30px;\n}\n\n#tournaments-games .tab-content .single-item .grid-style {\n  margin: 0 auto;\n  display: grid;\n  align-items: center;\n  text-align: center;\n}\n\n#tournaments-games .tab-content .single-item .grid-style h5 {\n  text-transform: uppercase;\n}\n\n#tournaments-games .tab-content .single-item .grid-style .prize {\n  padding: 15px 30px;\n  background: #191951;\n  border-radius: 10px;\n}\n\n#tournaments-games .tab-content .single-item .grid-style .prize img {\n  margin-right: 5px;\n}\n\n#tournaments-games .tab-content .single-item .grid-style .prize h5 {\n  color: #04f0f6;\n}\n\n#tournaments-games .tab-content .single-item .grid-style .bet {\n  text-transform: uppercase;\n  font-size: 16px;\n  line-height: 22px;\n}\n\n#tournaments-games .tab-content .single-item .grid-style .bet span {\n  color: #04f0f6;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n#tournaments-games .tab-content .single-item .list-right {\n  display: none;\n}\n\n#tournaments-games .tab-content .single-item.list .list-right {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 20px;\n  background: #090944;\n  border-radius: 20px;\n}\n\n#tournaments-games .tab-content .single-item.list .list-right .draw-counter .date-area span {\n  display: inline-block;\n}\n\n#tournaments-games .tab-content .single-item.list .list-right .draw-counter .time-parameter span {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  color: #03d6f9;\n  margin: 0 4px;\n}\n\n#tournaments-games .tab-content .single-item.list .list-right .end-on,\n#tournaments-games .tab-content .single-item .grid-style .end-on {\n  font-size: 14px;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n#tournaments-games .tab-content .single-item.list .list-right .end-on span,\n#tournaments-games .tab-content .single-item .grid-style .end-on span {\n  color: #04f0f6;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n#tournaments-games .tab-content .single-item.list {\n  flex: 0 0 100%;\n  -ms-flex: 0 0 100%;\n  max-width: 100%;\n}\n\n#tournaments-games .tab-content .single-item.list .grid-style .cmn-btn-second,\n#tournaments-games .tab-content .single-item.list .grid-style .end-on {\n  display: none;\n}\n\n.hero-banner {\n  /* background-image: url(../images/tournament/x50-hero.webp); */\n  padding-top: 100px;\n  padding-bottom: 200px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: black;\n}\n\n/* Tournaments Details */\n#banner-section.tourn-details {\n  padding-bottom: 0;\n}\n\n#banner-section.tourn-details .wi-100 {\n  width: 110%;\n}\n\n#banner-section.tourn-details .bottom-area {\n  background: #310e9e;\n  border-radius: 20px;\n  padding: 40px 0 0;\n  /* margin-bottom: -250px; */\n}\n\n#banner-section.tourn-details .bottom-area h3 {\n  text-transform: uppercase;\n  margin: 20px 0 30px;\n}\n\n#banner-section.tourn-details .bottom-area .prize-area {\n  padding: 15px 0 10px;\n  background: #370cbc;\n  margin-bottom: 30px;\n}\n\n#banner-section.tourn-details .bottom-area .bet-details {\n  margin-bottom: 40px;\n  padding: 0 15%;\n}\n\n#banner-section.tourn-details .bottom-area .bet-details h6,\n#banner-section.tourn-details .bottom-area .prize-area h6 {\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n}\n\n#banner-section.tourn-details .bottom-area .prize-area .prize {\n  margin-top: 10px;\n}\n\n#banner-section.tourn-details .bottom-area .prize-area h5 {\n  color: #04f0f6;\n  font-weight: 700;\n  margin-left: 5px;\n}\n\n#banner-section.tourn-details .bottom-area .bet-details h5 {\n  color: #04f0f6;\n  text-transform: uppercase;\n}\n\n#banner-section.tourn-details .bottom-area .bet-details h5 span {\n  color: var(--body-color);\n  text-transform: uppercase;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 700;\n}\n\n#banner-section.tourn-details .bottom-area .draw-counter {\n  padding: 10px 80px;\n  background: #370cbc;\n  border-radius: 20px;\n  display: inline-block;\n  margin-bottom: -30px;\n}\n\n#banner-section.tourn-details .bottom-area .draw-counter .time-parameter span {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: #04f0f6;\n}\n\n#banner-section.games.tourn-details .banner-content .banner-right-illu {\n  position: absolute;\n  right: 3%;\n  bottom: 0;\n  top: unset;\n}\n\n/* Tournament Start */\n#tournament-section {\n  background: #0d0d48;\n}\n\n#tournament-section .section-header {\n  margin-top: -12px;\n  margin-bottom: 30px;\n}\n\n#tournament-section .section-header h3 {\n  text-transform: uppercase;\n}\n\n#tournament-section .single-item img {\n  width: 100%;\n}\n\n#tournament-section .slick-initialized {\n  margin-bottom: -4px;\n}\n\n#tournament-section .slick-initialized .slick-arrow {\n  position: absolute;\n  background-color: transparent;\n  border-radius: 4px;\n  padding: 2px 5px;\n  line-height: 0;\n  outline: none;\n  transition: all 0.5s;\n}\n\n#tournament-section .slick-initialized .slick-next {\n  right: calc(8% - -10px);\n  top: -75px;\n  z-index: 1;\n}\n\n#tournament-section .slick-initialized .slick-prev {\n  right: calc(8% - 60px);\n  top: -75px;\n  z-index: 2;\n}\n\n#tournament-section .slick-initialized .slick-next,\n#tournament-section .slick-initialized .slick-prev {\n  width: 40px;\n  height: 40px;\n  background: #4e01ce;\n  box-shadow: 0px 4px 0px #4707b3;\n  border-radius: 10px;\n  display: inline-block;\n}\n\n#tournament-section .slick-initialized .slick-next:hover,\n#tournament-section .slick-initialized .slick-prev:hover {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #7400d3;\n}\n\n#tournament-section .slick-initialized .slick-prev::before,\n#tournament-section .slick-initialized .slick-next::before {\n  content: \"\";\n  height: 100px;\n  width: 100px;\n  position: absolute;\n  top: 13px;\n  left: 13px;\n}\n\n#tournament-section .slick-initialized .slick-prev::before {\n  background: url(../images/right-icon.png);\n  background-repeat: no-repeat;\n}\n\n#tournament-section .slick-initialized .slick-next::before {\n  background: url(../images/left-icon.png);\n  background-repeat: no-repeat;\n}\n\n/* Tournaments Prize */\n#tournaments-prize .price-rest {\n  background: #00102b;\n  border: 2px solid #04f0f633;\n  box-shadow: 0px 0px 15px 0px #7eebe833;\n  margin-top: 40px;\n  padding: 20px;\n  border-radius: 20px;\n  text-align: center;\n}\n\n#tournaments-prize .price-rest h4 {\n  color: #04f0f6;\n}\n\n#tournaments-prize .price-rest p.small {\n  margin-top: 10px;\n}\n\n#tournaments-prize .first-item {\n}\n\n@media (max-width: 991px) {\n  #tournaments-prize .first-item img {\n    height:350px;\n  }\n}\n\n#tournaments-prize .first-item .info {\n  border: 2px solid #ffffff;\n  box-shadow: 0px 0px 45px 0px #ffffff99;\n  padding: 20px 52px 30px 52px;\n  border-radius: 20px;\n}\n\n#tournaments-prize .first-item h6 {\n  color: #04f0f6;\n}\n \n#tournaments-prize .single-item {\n  position: relative;\n  background: #00102b;\n  border: 2px solid #04f0f633;\n  box-shadow: 0px 0px 15px 0px #7eebe833;\n  border-radius: 20px;\n  padding: 40px 0;\n}\n\n#tournaments-prize .single-item::before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  /* background: url(../images/prize-trophy-bg.png); */\n  background-repeat: no-repeat;\n  border-radius: 20px;\n  left: 0;\n  top: 0;\n}\n\n#tournaments-prize .single-item img {\n  width: 50%;\n}\n\n#tournaments-prize .single-item h6 {\n  color: #04f0f6;\n  margin: 20px 0 15px;\n}\n\n#tournaments-prize .cmn-btn {\n  margin-top: 60px;\n  border-radius: 10px;\n}\n\n#tournaments-prize .modal-content {\n  background: #19084d;\n  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.25);\n  border-radius: 20px;\n}\n\n#tournaments-prize .modal-body {\n  padding-bottom: 30px;\n}\n\n#tournaments-prize .modal-content .cmn-btn {\n  margin-top: 30px;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n#tournaments-prize .modal-header {\n  border: none;\n}\n\n#tournaments-prize .table {\n  background: #310e9e;\n  box-shadow: 0px 1px 0px #261687;\n  width: 99%;\n}\n\n#tournaments-prize thead th {\n  color: var(--body-color);\n  text-align: center;\n}\n\n#tournaments-prize tbody tr img {\n  margin-right: 10px;\n}\n\n#tournaments-prize tbody tr {\n  background: #31148b;\n  border: 1px solid #2f3998;\n}\n\n#tournaments-prize tbody tr td,\n#tournaments-prize tbody tr th {\n  color: var(--body-color);\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n}\n\n#tournaments-prize .table tbody tr:hover {\n  background: #13136c;\n  border-bottom: 1px solid #3f4aa9;\n  border-top: 1px solid #3f4aa9;\n  transition: all ease 0.3s;\n}\n\n/* tournament my information */\n#tournament-my-information .my-info {\n  padding: 30px 20px;\n  background: #00102b;\n  border: 2px solid #04f0f633;\n  box-shadow: 0px 0px 15px 0px #7eebe833;\n  border-radius: 20px;\n}\n\n#tournament-my-information .my-info .plus {\n  color: #04f0f6;\n}\n\n#tournament-my-information .my-info .minus {\n  color: #990e60;\n}\n\n/* leaderboard prize */\n#leaderboard-prize {\n  /* background: #220970; */\n  /* background-image: url(../images/leaderboard-bg.png); */\n  /* background-repeat: no-repeat; */\n  /* background-size: 100% 100%; */\n  /* margin-top: -390px; */\n}\n\n#leaderboard-prize .overlay {\n  /* transform: translateY(400px); */\n}\n\n#leaderboard-prize .table-responsive {\n  border: 2px solid #04f0f6;\n  box-shadow: 0px 0px 44px 0px #7eebe84d;\n  border-radius: 16px;\n}\n\n#leaderboard-prize .table {\n  /* background: #310e9e; */\n  /* box-shadow: 0px 1px 0px #261687; */\n  /* width: 99%; */\n  /* border: 2px solid #04F0F6;\n  box-shadow: 0px 0px 44px 0px #ff4d1666;\n  border-radius: 16px; */\n  margin-bottom: 0;\n}\n\n#leaderboard-prize thead th {\n  background: #00102b;\n  color: var(--body-color);\n  text-align: center;\n  padding: 20px 10px;\n}\n\n#leaderboard-prize tbody tr img {\n  /* margin-right: 10px; */\n  max-width: 50px;\n}\n\n#leaderboard-prize tbody tr {\n  background: #00102b;\n  border-top: 1px solid #ffb85c1a;\n  border-bottom: 1px solid #ffb85c1a;\n}\n\n#leaderboard-prize tbody tr td a {\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n#leaderboard-prize tbody tr td,\n#leaderboard-prize tbody tr th {\n  color: var(--body-color);\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: bold;\n  text-align: center;\n  vertical-align: middle;\n}\n\n#leaderboard-prize span.rank {\n  border-radius: 50px;\n  background: #00102b;\n  width: 50px;\n  height: 50px;\n  padding-top: 10px;\n}\n\n#leaderboard-prize span.rank-1 {\n  border: 3px solid #ffad2a;\n}\n\n#leaderboard-prize span.rank-2 {\n  border: 3px solid #b2e1eb;\n}\n\n#leaderboard-prize span.rank-3 {\n  border: 3px solid #af591d;\n}\n\n#leaderboard-prize .table tbody tr:hover {\n  /* background: #13136c; */\n  /* border-bottom: 1px solid #3f4aa9; */\n  /* border-top: 1px solid #3f4aa9; */\n  transition: all ease 0.3s;\n}\n\n#leaderboard-prize .cmn-btn {\n  margin-top: 35px;\n  border-radius: 10px;\n}\n\n#feature-section.tourn-details {\n  margin-top: 255px;\n}\n\n/* About Us */\n#banner-section.about {\n  padding-top: 202px;\n  padding-bottom: 0;\n  background-image: unset;\n}\n\n#banner-section .banner-bottom.about {\n  z-index: 1;\n  margin-top: -450px;\n}\n\n#banner-section .banner-bottom.about .main-content {\n  position: relative;\n  transform: translateY(480px);\n}\n\n#banner-section .banner-bottom.about .main-content::before {\n  position: absolute;\n  content: \"\";\n  background: #0d0d48;\n  border-radius: 20px;\n  width: 115%;\n  height: 80%;\n  left: -5%;\n  z-index: -1;\n}\n\n#banner-section .banner-bottom.about .item-area {\n  transform: translate(30px, -80px);\n}\n\n#banner-section .banner-bottom.about .item-area .content-item {\n  padding: 30px;\n  background-color: #31148b;\n  border-radius: 20px;\n}\n\n#banner-section .banner-bottom.about .item-area .single-item {\n  padding: 0;\n  width: 85%;\n  margin: 0 auto;\n}\n\n#banner-section .banner-bottom.about .item-area .single-item h2 {\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #04f0f6;\n}\n\n/* story behind gainio */\n#story-behind-gainio {\n  margin-top: 387px;\n  background-color: var(--body-bg);\n}\n\n#story-behind-gainio h2 {\n  text-transform: uppercase;\n}\n\n#story-behind-gainio p {\n  margin: 30px 0 34px;\n}\n\n#story-behind-gainio .btn-area a {\n  border-radius: 10px;\n  font-size: 13px;\n  line-height: 18px;\n  padding: 12px 18px;\n  margin: 0 15px;\n}\n\n/* Leading brand */\n#leading-brand {\n  background-color: #0d0d48;\n}\n\n#leading-brand .overlay {\n  position: relative;\n}\n\n#leading-brand .bg-right {\n  position: absolute;\n  right: -20%;\n}\n\n#leading-brand .single-item {\n  padding: 20px;\n  border: 1px solid #31148b;\n  border-radius: 10px;\n  margin-bottom: 30px;\n}\n\n#leading-brand .single-item .text-area h5 {\n  text-transform: uppercase;\n}\n\n#leading-brand .left-side .img-area {\n  width: 80px;\n  height: 80px;\n  background: #3b13b6;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 20px;\n}\n\n/* Team member */\n#team-member .single-item {\n  margin-bottom: 7px;\n}\n\n#team-member .single-item .img-area {\n  background: #03d6f9;\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  margin: 0 auto;\n  overflow: hidden;\n}\n\n#team-member .single-item .img-area img {\n  border-radius: 50%;\n  margin-top: 7px;\n}\n\n#team-member .single-item .bottom-area h5 {\n  text-transform: uppercase;\n  margin: 24px 0 30px;\n  text-align: center;\n}\n\n#team-member .social-area a {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 15px;\n}\n\n#team-member .social-area a img {\n  z-index: 1;\n}\n\n#team-member .social-area a::before {\n  position: absolute;\n  content: \"\";\n  z-index: 0;\n  width: 30px;\n  height: 30px;\n  /* background-image: url(../images/social-bg.png); */\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n#team-member .social-area a:hover::before {\n  /* background-image: url(../images/social-bg-hover.png); */\n  background-repeat: no-repeat;\n  transition: ease 0.5s;\n}\n\n/* FAQ Section  */\n#faq-page.faq .nav-tabs {\n  border: none;\n  display: flex;\n  justify-content: center;\n}\n\n#faq-page.faq .nav-tabs .nav-item {\n  margin: 0 10px;\n}\n\n#faq-page.faq .nav-tabs .nav-item .cmn-btn {\n  border-radius: 10px;\n  border: none;\n  background: #4e01ce;\n  box-shadow: 0px 4px 0px #4707b3;\n  font-weight: bold;\n  font-size: 13px;\n  line-height: 18px;\n  text-transform: uppercase;\n  color: var(--body-color);\n  padding: 20px 40px;\n}\n\n#faq-page.faq .nav-tabs .nav-item .cmn-btn.active {\n  background: #7400d3;\n  box-shadow: 0px 4px 0px #57049a;\n}\n\n#faq-page.faq .tab-content {\n  margin-bottom: -20px;\n}\n\n#faq-page.faq .tab-content .tab-pane h4 {\n  text-transform: uppercase;\n  text-align: center;\n  margin: 40px 0 35px;\n}\n\n#faq-page.faq .card {\n  border: none;\n  margin-bottom: 20px;\n}\n\n#faq-page.faq .card-header {\n  background-color: #1c1b74;\n}\n\n#faq-page.faq .card-body {\n  background-color: #08074c;\n  padding: 15px 30px 20px;\n}\n\n#faq-page.faq .card-header .btn-link {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  text-align: start;\n  text-decoration: none;\n  color: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  text-transform: uppercase;\n}\n\n#faq-page.faq .card-header .btn-link::before {\n  position: absolute;\n  content: \"\";\n  background-color: #016778;\n  right: 0;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n#faq-page.faq .card-header .collapsed.btn-link::after {\n  position: absolute;\n  content: \"\";\n  background-image: url(../images/plus-arrow.png);\n  background-repeat: no-repeat;\n  height: 15px;\n  width: 15px;\n  right: 8px;\n  transform: rotate(90deg);\n  transition: all ease 0.3s;\n}\n\n#faq-page.faq .card-header .btn-link::after {\n  background-image: url(../images/minus-arrow.png);\n  position: absolute;\n  content: \"\";\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n  transform: rotate(0deg);\n  transition: all ease 0.3s;\n  right: 5px;\n}\n\n.text-content h3 {\n  margin-top: 40px;\n}\n\n#index-announcement {\n}\n\n#index-announcement .info {\n  background-color: #141461;\n  margin-top: 40px;\n  padding: 20px;\n  border-radius: 20px;\n  text-align: center;\n}\n\n.countdown {\n  border: 2px solid #ffffff;\n  box-shadow: 0px 0px 44px 0px #7eebe84d;\n  border-radius: 20px;\n  color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #00102b;\n  color: white;\n  border-radius: 5px;\n}\n\n.countdown .counter {\n  display: flex;\n}\n\n@media (max-width: 400px) {\n  .time-unit {\n    padding: 5px!important;\n  }\n  .countdown-button-text {\n    font-size: smaller; \n    text-align: center;\n    line-height: 1.2; \n  }\n  .countdown .countdown-button {\n    padding-top:10px!important;\n    padding-bottom:10px!important;\n  }\n\n}\n\n.countdown .time-unit {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 35px;\n  font-weight: bold;\n}\n\n.countdown .time-unit .number {\n  font-size: 24px;\n}\n\n.countdown .time-unit .label {\n  font-size: 22px;\n  color: #ffffffcc;\n  margin-left: 5px;\n}\n\n.countdown .ttl {\n  text-transform: uppercase;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 18px;\n  margin-left: 15px;\n  font-weight: bold;\n}\n\n.countdown .countdown-button {\n  background-color: #00ccff;\n  color: white;\n  padding: 10px 20px;\n  font-size: 1em;\n  margin-left: 15px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.countdown .countdown-button a {\n  text-transform: uppercase;\n  text-decoration: none;\n  text-shadow: 0 0 1px #0039ff, 0 0 2px #00ccff;\n}\n\n@media (max-width: 991px) {\n  .countdown .countdown-button a {\n    font-size: 20px;\n  }\n}\n\n.modal .modal-giveaway h6 {\n  color: #000000;\n}\n\n.modal .modal-giveaway img {\n  border-radius: 10px;\n}\n\n.modal .modal-giveaway .modal-body {\n  padding: 0;\n}\n\n.modal .modal-giveaway .modal-content .comn-btn {\n  width: 100%;\n}\n\n.modal .modal-giveaway .modal-content {\n  background: #11a5a9;\n  box-shadow: 0px 20px 50px #11a5a9;\n  border-radius: 30px;\n}\n\n.modal .modal-giveaway .modal-header .btn-close {\n  display: none;\n}\n.modal .modal-giveaway .modal-header {\n  position: absolute;\n  top: -50;\n  z-index: 1;\n  border: none;\n}\n\n/* .modal .modal-giveaway .modal-content {\n  background-image: url(../images/banners/giveaway-banner.jpg);\n  background-repeat: no-repeat;\n  background-position: center center;\n} */\n\n/* responsive area */\n@media (min-width: 1200px) and (max-width: 1700px) {\n  #banner-section .banner-bottom.about .main-content::before {\n    width: 96%;\n    height: 80%;\n    left: 5%;\n  }\n  #banner-section.index-2 .banner-content .banner-side {\n    right: -15%;\n  }\n}\n\n@media (min-width: 991px) and (max-width: 1269.98px) {\n  #level-up-section .right-area .single-item img {\n    width: 70%;\n  }\n}\n\n@media (max-width: 1199px) {\n  .cmn-btn {\n    padding: 12px 20px;\n  }\n  #banner-section .banner-content .bottom-item {\n    margin-right: 0;\n    margin-left: 0;\n  }\n  #banner-section .main-content {\n    padding-bottom: 0;\n  }\n  .navbar-collapse .main-menu li a {\n    padding: 40px 12px;\n    font-weight: 800;\n    font-family: var(--body-font);\n    font-size: 18px;\n    text-transform: capitalize;\n  }\n  #leading-brand .bg-right {\n    right: -15%;\n    width: 45%;\n  }\n  #banner-section .banner-bottom.about .item-area {\n    transform: translate(0, -80px);\n  }\n  #banner-section .banner-bottom.about .main-content::before {\n    width: 82%;\n    height: 80%;\n    left: 9%;\n  }\n  #banner-section .banner-bottom.about .item-area .single-item {\n    width: 100%;\n  }\n  #faq-page.faq .nav-tabs .nav-item .cmn-btn {\n    padding: 16px 30px;\n  }\n  #available-game-section.games .overlay .menu-bar .cmn-btn {\n    padding: 12px 12px;\n  }\n  #available-game-section.games .overlay .menu-bar .cmn-btn {\n    padding: 12px 12px;\n  }\n  #feature-section .overlay .single-item .img-area {\n    margin-right: 10px;\n    width: 75px;\n    height: 75px;\n  }\n  #banner-section.index-2 .banner-content .banner-side {\n    right: -18%;\n    width: 55%;\n  }\n  #jackpot-section .right-area h1 span {\n    margin: -8px;\n  }\n  #banner-section .banner-bottom.about .main-content .ban-img {\n    width: 80%;\n  }\n  #banner-section .banner-bottom.about .main-content {\n    text-align: center;\n  }\n}\n\n@media (max-width: 991px) {\n  h1,\n  h1 > a {\n    font-size: 54px;\n    line-height: 64px;\n  }\n  h2,\n  h2 > a {\n    font-size: 40px;\n    line-height: 47px;\n  }\n  h3,\n  h3 > a {\n    font-size: 30px;\n    line-height: 36px;\n  }\n  h4,\n  h4 > a {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  h5,\n  h5 > a {\n    font-size: 18px;\n    line-height: 22px;\n  }\n  h6,\n  h6 > a,\n  a,\n  p,\n  span,\n  li,\n  .cmn-btn,\n  table thead tr th {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .section-header {\n    margin-bottom: 30px;\n  }\n  #header-section .navbar .navbar-nav .menu_has_children::after {\n    display: none;\n  }\n  .navbar-collapse .main-menu li a {\n    padding: 15px 12px;\n  }\n  #banner-section .banner-content .bottom-area img {\n    max-width: 70%;\n  }\n  #banner-section .banner-content .ani-illu img {\n    width: 25%;\n  }\n  #available-game-section .section-header {\n    width: 120%;\n  }\n  #available-game-section .right-area {\n    text-align: end;\n  }\n  #available-game-section .right-area .cmn-btn:first-child {\n    margin-bottom: 20px;\n  }\n  #available-game-section .contained-area {\n    margin-top: 30px;\n  }\n  #level-up-section .section-header {\n    margin-top: 60px;\n  }\n  #header-section .right-area .lang {\n    display: none !important;\n  }\n  #todays-winner-section .mid-area .jus-end {\n    justify-content: flex-end !important;\n    -ms-flex-align: flex-end !important;\n  }\n  #todays-winner-section .title-area {\n    margin-top: 60px;\n  }\n  #latest-activites-section .nav-tabs .nav-link {\n    font-weight: 700;\n    padding: 12px 20px;\n  }\n  #latest-activites-section .table {\n    width: 170%;\n  }\n  #latest-activites-section .table th,\n  #latest-activites-section .table td {\n    width: 0;\n  }\n  #level-up-section .left-area {\n    justify-content: center;\n  }\n  #faq-section .cus-mb {\n    justify-content: center;\n    margin: 100px 0 130px;\n  }\n  #footer-section .side-contant .right img {\n    right: 0;\n    top: -65px;\n  }\n  #footer-section .side-contant .left .bg {\n    top: -10px;\n    width: 40%;\n  }\n  #footer-section .subscribe input {\n    font-size: 14px;\n    padding: 10px 14px;\n  }\n  #footer-section .footer-bottom .left-area p {\n    font-size: 14px;\n    line-height: 20px;\n  }\n  #latest-activites-section.games .ani-div .obj-1 {\n    display: none;\n  }\n  #jackpot-section .slick-initialized .slick-prev,\n  #jackpot-section .slick-initialized .slick-next {\n    top: -30%;\n  }\n  #banner-section.games.tournaments.faq .banner-left {\n    width: 35%;\n  }\n  #banner-section.games.tournaments.faq .banner-right {\n    width: 40%;\n  }\n  #banner-section.games.faq {\n    padding-bottom: 35px;\n  }\n  #tournament-section .overlay {\n    margin-top: 140px;\n  }\n  #leaderboard-prize {\n    background-size: 100% 118%;\n    /* margin-top: -390px; */\n  }\n  #feature-section.tourn-details {\n    margin-top: 345px;\n  }\n  #footer-section .side-contant .left .top {\n    left: 10%;\n    top: 0;\n    width: 13%;\n  }\n  #footer-section .side-contant .right img {\n    right: 0;\n    bottom: 0;\n    width: 34%;\n    top: 80px;\n  }\n  #banner-section.games.tournaments .banner-right-illu {\n    right: -20%;\n    top: 0;\n    width: 50%;\n    bottom: 0;\n  }\n  #banner-section.home-2 .bottom-item .bottom-content {\n    padding: 40px 24px;\n  }\n  #banner-section.home-2 .bottom-item .right-area {\n    margin-top: 60px;\n  }\n  #faq-section .overlay .left-area span::after,\n  #faq-section .overlay .left-area::after,\n  #faq-section .overlay .left-area::before {\n    animation: none;\n  }\n  #banner-section .banner-bottom.about .main-content::before {\n    width: 100%;\n    height: 70%;\n    left: 0%;\n  }\n  #banner-section .banner-bottom.about .item-area .single-item {\n    width: 85%;\n  }\n  #leading-brand .bg-right {\n    right: -30%;\n    width: 45%;\n  }\n  #faq-page.faq .tab-content .tab-pane h4 {\n    margin: 30px 0 30px;\n  }\n  #available-game-section.index-2 .nav-tabs {\n    border: none;\n    margin-top: 18px;\n  }\n  #todays-winner-section.games .right-side {\n    padding: 4px 0 10px;\n  }\n  #todays-winner-section.games .left-side {\n    margin-bottom: 30px;\n  }\n  #tournaments-games .nav-tabs .nav-item {\n    margin: 5px;\n    margin-right: initial;\n  }\n  #tournaments-games .tab-pane .mb-cus {\n    margin: 30px 0;\n    justify-content: space-around;\n  }\n  #tournaments-games .tab-content .single-item.list .content-area {\n    display: flex;\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item .content-area {\n    display: grid;\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item .grid-style .head-area {\n    margin: 12px 0;\n  }\n  #tournaments-games .tab-content .single-item .grid-style .bet {\n    margin: 15px 0;\n  }\n  #tournaments-games .tab-content .single-item .cmn-btn-second {\n    margin-bottom: 15px;\n  }\n  #level-up-section.games {\n    margin-top: 110px;\n  }\n  #available-game-section.index-2.games-2 .nav-tabs {\n    border: none;\n    margin-top: 18px;\n    justify-content: center;\n    margin-bottom: 25px;\n  }\n  #affiliate-program.game-2 .affiliate-illu {\n    position: absolute;\n    right: -10%;\n    bottom: 0;\n    max-width: 45%;\n  }\n  #feature-section {\n    margin-top: 110px;\n  }\n  #feature-section .overlay .single-item {\n    margin-bottom: 20px;\n  }\n  #feature-section .overlay .row {\n    margin-bottom: -20px;\n  }\n  #testimonial .single-item {\n    padding: 15px 7px;\n  }\n  .bottom-item .bottom-content {\n    padding: 60px 24px;\n  }\n  #level-up-section.index-2 {\n    margin-top: 50px;\n  }\n  #jackpot-section {\n    padding-bottom: 90px;\n  }\n  #features-section {\n    margin-top: 120px;\n  }\n  #counter-section .single-item {\n    margin-top: 30px;\n    padding-bottom: 30px;\n  }\n  #counter-section.index-2 .main-content {\n    padding-top: 0;\n    padding-bottom: 10px;\n  }\n  #banner-section.index-2 .banner-content .banner-side {\n    display: none;\n  }\n}\n\n@media (max-width: 767px) {\n  .justify-cen {\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n  }\n  #banner-section .banner-content .ani-img img {\n    width: 30%;\n  }\n  #banner-section .banner-content .single-item {\n    align-items: center;\n  }\n  .section-header {\n    margin-top: -12px;\n    margin-bottom: 30px;\n  }\n  .cmn-btn {\n    padding: 10px 15px;\n  }\n  #available-game-section .section-header {\n    text-align: center;\n  }\n  #available-game-section .section-header {\n    width: initial;\n  }\n  #latest-activites-section .section-header {\n    text-align: center;\n  }\n  #latest-activites-section .nav-tabs {\n    margin-bottom: 30px;\n  }\n  #latest-activites-section .table {\n    width: 240%;\n  }\n  #footer-section .side-contant {\n    display: none;\n  }\n  #footer-section .social-area {\n    margin-top: 50px;\n  }\n  #footer-section .order-pro {\n    order: 1;\n  }\n  #footer-section .footer-bottom .left-area p {\n    margin-top: 20px;\n  }\n  #footer-section .bottom-area ul li a {\n    padding-left: 15px;\n  }\n  #banner-section.games.faq {\n    padding-bottom: 15px;\n  }\n  #banner-section .banner-bottom.about .item-area .content-item {\n    padding: 20px;\n  }\n  #banner-section .banner-bottom.about .item-area .single-item {\n    width: 100%;\n  }\n  #banner-section.games .banner-side {\n    right: 2%;\n    bottom: 6%;\n    width: 50%;\n  }\n  #banner-section.about {\n    padding-top: 150px;\n    padding-bottom: 50px;\n    background-image: unset;\n  }\n  #banner-section .banner-bottom.about .main-content {\n    position: relative;\n    transform: translateY(420px);\n  }\n  #tournament-section .overlay {\n    margin-top: 200px;\n  }\n  #banner-section.games.tournaments .banner-right-illu {\n    right: -20%;\n    top: 0;\n    width: 0;\n    bottom: 0;\n  }\n  #banner-section.games.tournaments .banner-right {\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 60%;\n  }\n  #jackpot-section .slick-initialized .slick-next,\n  #jackpot-section .slick-initialized .slick-prev {\n    top: -40%;\n  }\n  #faq-section .cus-mb {\n    margin: 55px 0 80px;\n  }\n  #available-game-section.home-2.index-2 .nav-tabs {\n    display: flex;\n  }\n  #banner-section.home-2 {\n    padding-top: 90px;\n  }\n  #tournaments-games .tab-pane .mb-cus .md-none {\n    display: none !important;\n  }\n  #tournaments-games .tab-content .nice-select {\n    padding: 7px 8px;\n  }\n  #tournaments-games .nav-tabs {\n    margin-top: 10px;\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item.list {\n    display: grid;\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item.list .content-area {\n    display: grid;\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item.list .grid-style {\n    text-align: center;\n    margin: 0 30px;\n  }\n  #tournaments-games .tab-content .single-item.list:after {\n    border: 0;\n  }\n  #tournaments-games .tab-content .single-item,\n  #tournaments-games .tab-content .single-item.list {\n    flex: 0 0 calc(100% / 2 - 15px);\n    -ms-flex: 0 0 calc(100% / 2 - 15px);\n    max-width: calc(100% / 2 - 15px);\n    padding: 15px 10px;\n  }\n  #tournaments-games .tab-content .single-item.list .content-area img {\n    width: 100%;\n  }\n  #tournaments-games .tab-content .single-item.list .list-right {\n    padding: 10px;\n  }\n  #tournaments-games .tab-content .single-item.list .list-right .draw-counter {\n    margin: 10px 0;\n  }\n  #story-behind-gainio {\n    margin-top: 280px;\n    background-color: var(--body-bg);\n  }\n  #team-member .mb-cus {\n    margin-bottom: -55px;\n  }\n  #team-member .single-item {\n    margin-bottom: 55px;\n  }\n  #banner-section.inner-banner .breadcrumb-area ol li,\n  #banner-section.inner-banner .breadcrumb-area ol li a {\n    font-size: 18px;\n  }\n  #faq-page.faq .nav-tabs .nav-item .cmn-btn {\n    padding: 10px 13px;\n  }\n  #faq-page.faq .card-header .btn-link {\n    width: 95%;\n  }\n  #faq-page.faq .card-header .btn-link::after {\n    right: -4.3% !important;\n  }\n  #faq-page.faq .card-header .btn-link::before {\n    right: -5.9% !important;\n  }\n  #banner-section.games.tournaments .banner-left {\n    left: -8%;\n    top: 10%;\n    width: 50%;\n  }\n  #banner-section.games {\n    padding-top: 140px;\n    padding-bottom: 0;\n  }\n  .bottom-item .right-area {\n    margin-top: 30px;\n  }\n  #jackpot-section {\n    background-size: 330%;\n    background-position-x: 43%;\n  }\n}\n\n@media (max-width: 575px) {\n  h1,\n  h1 > a {\n    font-size: 40px;\n    line-height: 46px;\n  }\n  h2,\n  h2 > a {\n    font-size: 30px;\n    line-height: 36px;\n  }\n  h3,\n  h3 > a {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  h4,\n  h4 > a {\n    font-size: 18px;\n    line-height: 22px;\n  }\n  h5,\n  h5 > a {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  h6,\n  h6 > a,\n  a,\n  p,\n  span,\n  li,\n  .cmn-btn,\n  table thead tr th {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  #banner-section {\n    padding-top: 130px;\n  }\n  #jackpot-section .slick-initialized .slick-prev {\n    right: 0;\n  }\n  #jackpot-section .slick-initialized .slick-next {\n    right: 70px;\n  }\n  #faq-section .overlay .left-area,\n  #faq-section .overlay .left-area span {\n    text-align: center;\n  }\n  #feature-game-section .section-header {\n    text-align: center;\n  }\n  #available-game-section .contained-area .col-lg-3 {\n    text-align: center;\n  }\n  #footer-section .footer-top .col-lg-6 {\n    padding: 0 30px;\n  }\n  #feature-game-section .feature-game-carousel {\n    margin-top: 30px;\n  }\n  #level-up-section .right-area .single-item img {\n    max-width: 60%;\n  }\n  #level-up-section .section-header {\n    text-align: center;\n  }\n  #banner-section.games.tournaments.faq .banner-right {\n    width: 42%;\n    top: 70px;\n  }\n  #banner-section.games.faq {\n    padding-bottom: 0;\n  }\n  #todays-winner-section.home .section-header {\n    margin-bottom: 30px;\n    text-align: center;\n  }\n  #todays-winner-section .jus-end {\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .mb-cus .col-lg-3 {\n    padding: 0 15%;\n    margin-bottom: 15px;\n  }\n  #tournaments-games .tab-content .nice-select {\n    padding: 7px 15px;\n  }\n  #faq-section .overlay .left-area img {\n    max-width: 50%;\n  }\n  #faq-section .overlay .left-area span::before {\n    padding: 80px;\n  }\n  #faq-section .overlay .left-area span::after {\n    padding: 110px;\n    left: 15%;\n    top: -15%;\n  }\n  #faq-section .overlay .left-area::before {\n    padding: 125px;\n    left: 10%;\n    top: -23%;\n  }\n  #faq-section .overlay .left-area::after {\n    padding: 140px;\n    left: 5%;\n    top: -30%;\n  }\n  #footer-section .section-header p {\n    font-size: 16px;\n    line-height: 20px;\n  }\n  #header-section .header-area {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  #banner-section.inner-banner .breadcrumb-area ol li,\n  #banner-section.inner-banner .breadcrumb-area ol li a {\n    font-size: 16px;\n  }\n  #tournament-section .slick-initialized .slick-prev {\n    right: 0;\n  }\n  #tournaments-prize .single-item {\n    margin-bottom: 30px;\n  }\n  #tournaments-prize .cmn-btn {\n    margin-top: 10px;\n  }\n\n  .vector-title {\n    padding-bottom: 25px;\n  }\n\n  #home-here .hero-banner {\n    height: 600px;\n  }\n\n  #home-here .hero-banner .bottom-area {\n    padding-top: 150px;\n  }\n\n  .countdown {\n    flex-direction: column;\n  }\n  .countdown .time-unit {\n    padding: 15px;\n  }\n\n  .countdown .countdown-button {\n    width: 100%;\n    margin: 0;\n  }\n\n  #home-here .hero-banner .bottom-area .bet-details {\n    padding: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  #banner-section .banner-content .single-item .left-area img {\n    margin: 0 15px;\n    max-width: 70%;\n  }\n  #banner-section .banner-content .single-item {\n    padding: 25px 15px 21px 0;\n  }\n  #available-game-section .right-area {\n    text-align: center;\n  }\n  #level-up-section .right-area .justify-content-between {\n    display: grid !important;\n    justify-content: center !important;\n    margin-bottom: -30px;\n  }\n  #level-up-section .right-area .single-item img {\n    max-width: 90px;\n  }\n  #level-up-section .right-area .single-item {\n    margin-bottom: 30px;\n  }\n  #level-up-section .right-area .single-item h6 {\n    margin-top: 15px;\n  }\n  #todays-winner-section .winner-chart .single-item {\n    text-align: center !important;\n    justify-content: center !important;\n    display: grid !important;\n    padding: 30px 0;\n  }\n  #todays-winner-section .winner-chart .single-item .left-area .name-area {\n    margin: 20px 0;\n  }\n  #todays-winner-section .winner-chart .single-item .left-area {\n    display: grid !important;\n    justify-content: center !important;\n  }\n  #todays-winner-section .winner-chart .single-item .left-area .pos {\n    margin: auto;\n  }\n  #counter-section .single-item {\n    margin-bottom: 30px;\n  }\n  #counter-section .single-item span {\n    font-size: 20px;\n    line-height: 28px;\n    margin: 5px 0 2px;\n  }\n  #jackpot-section .right-area .couter-area {\n    margin: 30px 0 30px;\n  }\n  #jackpot-section .carousel-jackpot .single-item h6 {\n    top: 10px;\n    left: 15px;\n    padding: 10px 12px;\n  }\n  #latest-activites-section .table-responsive {\n    padding: 10px;\n  }\n  #latest-activites-section .table {\n    width: 230%;\n  }\n  #latest-activites-section .table th,\n  #latest-activites-section .table td {\n    padding-left: 10px;\n  }\n  #faq-page.faq .nav-tabs .nav-item {\n    margin: 8px 10px;\n  }\n  #leaderboard-prize .table {\n    width: 130%;\n  }\n  .card-header {\n    padding: 12px 0 12px 0;\n  }\n  #faq-section .overlay .card-header .btn-link {\n    text-align: start;\n    padding-right: 40px;\n  }\n  #faq-section .overlay .card-header .collapsed.btn-link::after {\n    right: 18px;\n  }\n  #faq-section .overlay .card-header .btn-link::before {\n    right: 10px;\n  }\n  #faq-section .overlay .card-header .btn-link::after {\n    right: 15px;\n  }\n  #faq-section .overlay .card-body {\n    padding: 12px 15px 12px;\n  }\n  #tournaments-games .tab-content .all-items {\n    justify-content: center;\n  }\n  #tournaments-games .tab-content .single-item,\n  #tournaments-games .tab-content .single-item.list {\n    flex: 0 0 calc(100% / 1 - 15px);\n    -ms-flex: 0 0 calc(100% / 1 - 15px);\n    max-width: calc(100% / 1 - 15px);\n    padding: 15px 10px;\n  }\n  #footer-section .section-header p {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  #footer-section .footer-bottom .left-area p {\n    margin: 35px 12px 0;\n    line-height: 26px;\n    text-align: center;\n  }\n  #footer-section .bottom-area .header-area .col-lg-8 {\n    display: grid !important;\n  }\n  #footer-section .bottom-area .header-area .logo-section {\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  #banner-section .banner-bottom.about .item-area .content-item {\n    display: grid !important;\n  }\n  #banner-section .banner-bottom.about .item-area .mb-cus {\n    margin-bottom: 0 !important;\n  }\n  #banner-section .banner-bottom.about .item-area .single-item {\n    margin-bottom: 30px;\n  }\n  #banner-section.games .banner-side {\n    right: 2%;\n    bottom: 6%;\n    width: 50%;\n  }\n  #leading-brand .bg-right {\n    display: none;\n  }\n  #faq-page.faq .card-header .btn-link::after {\n    right: -0.3% !important;\n  }\n  #faq-page.faq .card-header .btn-link::before {\n    right: -2.9% !important;\n  }\n  #available-game-section.index-2.games-2 .nav-tabs {\n    display: flex;\n  }\n  #available-game-section.index-2 .nav-tabs {\n    display: grid;\n  }\n  #available-game-section.index-2 .nav-tabs .nav-item {\n    margin: 11px 18px;\n    text-align: center;\n  }\n  #available-game-section.games .overlay .menu-bar .cmn-btn {\n    padding: 8px 12px;\n  }\n  #jackpot-section .right-area h1 span {\n    padding: 15px 6px;\n    margin: -5px;\n  }\n  #banner-section.tourn-details .bottom-area .bet-details {\n    padding: 0 3%;\n  }\n  #tournament-section .section-header h3 {\n    width: 55%;\n  }\n  #tournament-section .slick-initialized .slick-next {\n    right: 55px;\n  }\n}\n\n@media (max-width: 420px) {\n  #latest-activites-section .table {\n    width: 394%;\n  }\n  #banner-section .banner-bottom.about .item-area {\n    transform: translate(0, -20px);\n  }\n  #story-behind-gainio {\n    margin-top: 330px;\n    background-color: var(--body-bg);\n  }\n  #story-behind-gainio .btn-area a {\n    padding: 10px 12px;\n    margin: 0 7px;\n  }\n}\n\n.mid {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.bet-details {\n  position: relative;\n  text-align: center;\n  display: flex; \n  justify-content: space-between;\n}\n\n.bet-details .left, .bet-details .right {\n  min-width: 50px;\n}\n\n.bet-details .mid {\n  flex-grow: 1;\n} \n \n@media (min-width: 601px) {\n  .flex-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n \n@media (max-width: 600px) {\n  .flex-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .TournamentEnrollment {\n    padding-top:20px;\n    padding-bottom:20px;\n  }\n}\n\n.btnLogin {\n  border-left:2px solid #ffffff;\n  margin-top:20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
